// source: buying/consumer_search/api/v1/server.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var buying_auctions_api_v1_types_pb = require('../../../../buying/auctions/api/v1/types_pb.js');
goog.object.extend(proto, buying_auctions_api_v1_types_pb);
var buying_drops_api_v1_types_pb = require('../../../../buying/drops/api/v1/types_pb.js');
goog.object.extend(proto, buying_drops_api_v1_types_pb);
var buying_trivia_api_v1_types_pb = require('../../../../buying/trivia/api/v1/types_pb.js');
goog.object.extend(proto, buying_trivia_api_v1_types_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.buying.consumer_search.api.v1.ActivityFilter', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.Aggregation', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.AggregationBucket', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.AggregationBucketResponse', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.AggregationField', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.AggregationType', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.AggregationValue', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.AvailableFilter', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.AvailableGenderFilter', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.AvailableSizeFilter', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.BoxCondition', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.CollapseOn', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.CollectionProduct', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.EventGroup', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.EventSearchRequest', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.EventSearchResponse', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.EventSortType', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.FilterDetail', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.ForProductSortType', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetCollectionContentsRequest', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetCollectionContentsResponse', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetProductAggregationsRequest', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetProductAggregationsResponse', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetProductsByIDRequest', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetProductsByIDResponse', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetRecordCountRequest', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetRecordCountResponse', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetRecordsForProductRequest', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetRecordsForProductResponse', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetSubCollectionsRequest', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GetSubCollectionsResponse', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.GiftShopProduct', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.Money', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.Product', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.ProductCategoryFilter', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.ProductCondition', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.ProductFilter', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.ProductItem', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.ProductSearchRequest', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.ProductSearchResponse', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.ProductSortType', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.ProductTypeFilter', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.RecordType', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.ResultItem', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.SalesChannel', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.SearchSuggestionsRequest', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.SearchSuggestionsResponse', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.ServiceResultItem', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.ServiceResultItem.ItemTypeCase', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.SizeFilter', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.SizeFilterDetail', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.SizeFilterGender', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.SizeFilterProductType', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.SizeFilterSizeUnit', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.SubCollection', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.Tag', null, global);
goog.exportSymbol('proto.buying.consumer_search.api.v1.Variant', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.SearchSuggestionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.displayName = 'proto.buying.consumer_search.api.v1.SearchSuggestionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.ProductItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.ProductItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.ProductItem.displayName = 'proto.buying.consumer_search.api.v1.ProductItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.ResultItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.ResultItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.ResultItem.displayName = 'proto.buying.consumer_search.api.v1.ResultItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.SearchSuggestionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.displayName = 'proto.buying.consumer_search.api.v1.SearchSuggestionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.EventSearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.EventSearchRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.EventSearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.EventSearchRequest.displayName = 'proto.buying.consumer_search.api.v1.EventSearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GiftShopProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GiftShopProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GiftShopProduct.displayName = 'proto.buying.consumer_search.api.v1.GiftShopProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.ServiceResultItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.buying.consumer_search.api.v1.ServiceResultItem.oneofGroups_);
};
goog.inherits(proto.buying.consumer_search.api.v1.ServiceResultItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.ServiceResultItem.displayName = 'proto.buying.consumer_search.api.v1.ServiceResultItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.EventSearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.EventSearchResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.EventSearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.EventSearchResponse.displayName = 'proto.buying.consumer_search.api.v1.EventSearchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.GetProductsByIDRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetProductsByIDRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetProductsByIDRequest.displayName = 'proto.buying.consumer_search.api.v1.GetProductsByIDRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.Money = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.Money, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.Money.displayName = 'proto.buying.consumer_search.api.v1.Money';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.Variant = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.Variant, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.Variant.displayName = 'proto.buying.consumer_search.api.v1.Variant';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.Product = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.Product.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.Product, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.Product.displayName = 'proto.buying.consumer_search.api.v1.Product';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetProductsByIDResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.GetProductsByIDResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetProductsByIDResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetProductsByIDResponse.displayName = 'proto.buying.consumer_search.api.v1.GetProductsByIDResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetRecordsForProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.displayName = 'proto.buying.consumer_search.api.v1.GetRecordsForProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetRecordsForProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.displayName = 'proto.buying.consumer_search.api.v1.GetRecordsForProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.SizeFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.SizeFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.SizeFilter.displayName = 'proto.buying.consumer_search.api.v1.SizeFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.ProductFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.ProductFilter.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.ProductFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.ProductFilter.displayName = 'proto.buying.consumer_search.api.v1.ProductFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.ProductSearchRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.ProductSearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.ProductSearchRequest.displayName = 'proto.buying.consumer_search.api.v1.ProductSearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.FilterDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.FilterDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.FilterDetail.displayName = 'proto.buying.consumer_search.api.v1.FilterDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.ActivityFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.ActivityFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.ActivityFilter.displayName = 'proto.buying.consumer_search.api.v1.ActivityFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.ProductTypeFilter.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.ProductTypeFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.ProductTypeFilter.displayName = 'proto.buying.consumer_search.api.v1.ProductTypeFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.ProductCategoryFilter.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.ProductCategoryFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.ProductCategoryFilter.displayName = 'proto.buying.consumer_search.api.v1.ProductCategoryFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.SizeFilterDetail.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.SizeFilterDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.SizeFilterDetail.displayName = 'proto.buying.consumer_search.api.v1.SizeFilterDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.AvailableGenderFilter.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.AvailableGenderFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.AvailableGenderFilter.displayName = 'proto.buying.consumer_search.api.v1.AvailableGenderFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.AvailableSizeFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.AvailableSizeFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.AvailableSizeFilter.displayName = 'proto.buying.consumer_search.api.v1.AvailableSizeFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.AvailableFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.AvailableFilter.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.AvailableFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.AvailableFilter.displayName = 'proto.buying.consumer_search.api.v1.AvailableFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.ProductSearchResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.ProductSearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.ProductSearchResponse.displayName = 'proto.buying.consumer_search.api.v1.ProductSearchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.AggregationBucket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.AggregationBucket.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.AggregationBucket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.AggregationBucket.displayName = 'proto.buying.consumer_search.api.v1.AggregationBucket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetProductAggregationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.displayName = 'proto.buying.consumer_search.api.v1.GetProductAggregationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.AggregationValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.AggregationValue.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.AggregationValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.AggregationValue.displayName = 'proto.buying.consumer_search.api.v1.AggregationValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.AggregationBucketResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.AggregationBucketResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.AggregationBucketResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.AggregationBucketResponse.displayName = 'proto.buying.consumer_search.api.v1.AggregationBucketResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetProductAggregationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.displayName = 'proto.buying.consumer_search.api.v1.GetProductAggregationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetCollectionContentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.displayName = 'proto.buying.consumer_search.api.v1.GetCollectionContentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.CollectionProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.CollectionProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.CollectionProduct.displayName = 'proto.buying.consumer_search.api.v1.CollectionProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetCollectionContentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.displayName = 'proto.buying.consumer_search.api.v1.GetCollectionContentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetRecordCountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetRecordCountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetRecordCountRequest.displayName = 'proto.buying.consumer_search.api.v1.GetRecordCountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetRecordCountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetRecordCountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetRecordCountResponse.displayName = 'proto.buying.consumer_search.api.v1.GetRecordCountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.displayName = 'proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.displayName = 'proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.displayName = 'proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.displayName = 'proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.displayName = 'proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.displayName = 'proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetSubCollectionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.displayName = 'proto.buying.consumer_search.api.v1.GetSubCollectionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.SubCollection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.SubCollection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.SubCollection.displayName = 'proto.buying.consumer_search.api.v1.SubCollection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.consumer_search.api.v1.GetSubCollectionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.displayName = 'proto.buying.consumer_search.api.v1.GetSubCollectionsResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.SearchSuggestionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
salesChannelsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
queryString: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageLimit: jspb.Message.getFieldWithDefault(msg, 3, 0),
productLimit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsRequest}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.SearchSuggestionsRequest;
  return proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.SearchSuggestionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsRequest}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.buying.consumer_search.api.v1.SalesChannel>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSalesChannels(values[i]);
      }
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQueryString(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPageLimit(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProductLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.SearchSuggestionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSalesChannelsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getQueryString();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageLimit();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getProductLimit();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated SalesChannel sales_channels = 1;
 * @return {!Array<!proto.buying.consumer_search.api.v1.SalesChannel>}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.prototype.getSalesChannelsList = function() {
  return /** @type {!Array<!proto.buying.consumer_search.api.v1.SalesChannel>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.SalesChannel>} value
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsRequest} returns this
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.prototype.setSalesChannelsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SalesChannel} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsRequest} returns this
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.prototype.addSalesChannels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsRequest} returns this
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.prototype.clearSalesChannelsList = function() {
  return this.setSalesChannelsList([]);
};


/**
 * optional string query_string = 2;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.prototype.getQueryString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsRequest} returns this
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.prototype.setQueryString = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 page_limit = 3;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.prototype.getPageLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsRequest} returns this
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.prototype.setPageLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 product_limit = 4;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.prototype.getProductLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsRequest} returns this
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsRequest.prototype.setProductLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.ProductItem.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.ProductItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.ProductItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ProductItem.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
slug: jspb.Message.getFieldWithDefault(msg, 3, ""),
imageUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
category: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.ProductItem}
 */
proto.buying.consumer_search.api.v1.ProductItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.ProductItem;
  return proto.buying.consumer_search.api.v1.ProductItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.ProductItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.ProductItem}
 */
proto.buying.consumer_search.api.v1.ProductItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.ProductItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.ProductItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.ProductItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ProductItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ProductItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ProductItem} returns this
 */
proto.buying.consumer_search.api.v1.ProductItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ProductItem.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ProductItem} returns this
 */
proto.buying.consumer_search.api.v1.ProductItem.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slug = 3;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ProductItem.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ProductItem} returns this
 */
proto.buying.consumer_search.api.v1.ProductItem.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string image_url = 4;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ProductItem.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ProductItem} returns this
 */
proto.buying.consumer_search.api.v1.ProductItem.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string category = 5;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ProductItem.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ProductItem} returns this
 */
proto.buying.consumer_search.api.v1.ProductItem.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.ResultItem.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.ResultItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.ResultItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ResultItem.toObject = function(includeInstance, msg) {
  var f, obj = {
recordId: jspb.Message.getFieldWithDefault(msg, 1, ""),
recordType: jspb.Message.getFieldWithDefault(msg, 2, 0),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
slug: jspb.Message.getFieldWithDefault(msg, 4, ""),
recordSubtype: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.ResultItem}
 */
proto.buying.consumer_search.api.v1.ResultItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.ResultItem;
  return proto.buying.consumer_search.api.v1.ResultItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.ResultItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.ResultItem}
 */
proto.buying.consumer_search.api.v1.ResultItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecordId(value);
      break;
    case 2:
      var value = /** @type {!proto.buying.consumer_search.api.v1.RecordType} */ (reader.readEnum());
      msg.setRecordType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecordSubtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.ResultItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.ResultItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.ResultItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ResultItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecordId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRecordType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRecordSubtype();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string record_id = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ResultItem.prototype.getRecordId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ResultItem} returns this
 */
proto.buying.consumer_search.api.v1.ResultItem.prototype.setRecordId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional RecordType record_type = 2;
 * @return {!proto.buying.consumer_search.api.v1.RecordType}
 */
proto.buying.consumer_search.api.v1.ResultItem.prototype.getRecordType = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.RecordType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.RecordType} value
 * @return {!proto.buying.consumer_search.api.v1.ResultItem} returns this
 */
proto.buying.consumer_search.api.v1.ResultItem.prototype.setRecordType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ResultItem.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ResultItem} returns this
 */
proto.buying.consumer_search.api.v1.ResultItem.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string slug = 4;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ResultItem.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ResultItem} returns this
 */
proto.buying.consumer_search.api.v1.ResultItem.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string record_subtype = 5;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ResultItem.prototype.getRecordSubtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ResultItem} returns this
 */
proto.buying.consumer_search.api.v1.ResultItem.prototype.setRecordSubtype = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.SearchSuggestionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
totalResults: jspb.Message.getFieldWithDefault(msg, 1, 0),
resultItemsList: jspb.Message.toObjectList(msg.getResultItemsList(),
    proto.buying.consumer_search.api.v1.ResultItem.toObject, includeInstance),
productItemsList: jspb.Message.toObjectList(msg.getProductItemsList(),
    proto.buying.consumer_search.api.v1.ProductItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsResponse}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.SearchSuggestionsResponse;
  return proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.SearchSuggestionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsResponse}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalResults(value);
      break;
    case 2:
      var value = new proto.buying.consumer_search.api.v1.ResultItem;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.ResultItem.deserializeBinaryFromReader);
      msg.addResultItems(value);
      break;
    case 3:
      var value = new proto.buying.consumer_search.api.v1.ProductItem;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.ProductItem.deserializeBinaryFromReader);
      msg.addProductItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.SearchSuggestionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalResults();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getResultItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.buying.consumer_search.api.v1.ResultItem.serializeBinaryToWriter
    );
  }
  f = message.getProductItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.buying.consumer_search.api.v1.ProductItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 total_results = 1;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.prototype.getTotalResults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsResponse} returns this
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.prototype.setTotalResults = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated ResultItem result_items = 2;
 * @return {!Array<!proto.buying.consumer_search.api.v1.ResultItem>}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.prototype.getResultItemsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.ResultItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.ResultItem, 2));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.ResultItem>} value
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsResponse} returns this
*/
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.prototype.setResultItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.ResultItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ResultItem}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.prototype.addResultItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.buying.consumer_search.api.v1.ResultItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsResponse} returns this
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.prototype.clearResultItemsList = function() {
  return this.setResultItemsList([]);
};


/**
 * repeated ProductItem product_items = 3;
 * @return {!Array<!proto.buying.consumer_search.api.v1.ProductItem>}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.prototype.getProductItemsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.ProductItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.ProductItem, 3));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.ProductItem>} value
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsResponse} returns this
*/
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.prototype.setProductItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.ProductItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductItem}
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.prototype.addProductItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.buying.consumer_search.api.v1.ProductItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.SearchSuggestionsResponse} returns this
 */
proto.buying.consumer_search.api.v1.SearchSuggestionsResponse.prototype.clearProductItemsList = function() {
  return this.setProductItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.repeatedFields_ = [1,2,8,9,11,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.EventSearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.EventSearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
salesChannelsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
recordTypesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
pageLimit: jspb.Message.getFieldWithDefault(msg, 3, 0),
eventTimeAfter: (f = msg.getEventTimeAfter()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
eventTimeBefore: (f = msg.getEventTimeBefore()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
pageNumber: jspb.Message.getFieldWithDefault(msg, 6, 0),
collapseOn: jspb.Message.getFieldWithDefault(msg, 7, 0),
eventGroupIncludesList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
eventGroupExcludesList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
collapseLimit: jspb.Message.getFieldWithDefault(msg, 10, 0),
tagsIncludeList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
tagsExcludeList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
sortType: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.EventSearchRequest;
  return proto.buying.consumer_search.api.v1.EventSearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.EventSearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.buying.consumer_search.api.v1.SalesChannel>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSalesChannels(values[i]);
      }
      break;
    case 2:
      var values = /** @type {!Array<!proto.buying.consumer_search.api.v1.RecordType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRecordTypes(values[i]);
      }
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPageLimit(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEventTimeAfter(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEventTimeBefore(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPageNumber(value);
      break;
    case 7:
      var value = /** @type {!proto.buying.consumer_search.api.v1.CollapseOn} */ (reader.readEnum());
      msg.setCollapseOn(value);
      break;
    case 8:
      var values = /** @type {!Array<!proto.buying.consumer_search.api.v1.EventGroup>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addEventGroupIncludes(values[i]);
      }
      break;
    case 9:
      var values = /** @type {!Array<!proto.buying.consumer_search.api.v1.EventGroup>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addEventGroupExcludes(values[i]);
      }
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCollapseLimit(value);
      break;
    case 11:
      var values = /** @type {!Array<!proto.buying.consumer_search.api.v1.Tag>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addTagsInclude(values[i]);
      }
      break;
    case 12:
      var values = /** @type {!Array<!proto.buying.consumer_search.api.v1.Tag>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addTagsExclude(values[i]);
      }
      break;
    case 13:
      var value = /** @type {!proto.buying.consumer_search.api.v1.EventSortType} */ (reader.readEnum());
      msg.setSortType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.EventSearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.EventSearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSalesChannelsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getRecordTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getPageLimit();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getEventTimeAfter();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEventTimeBefore();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCollapseOn();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getEventGroupIncludesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      8,
      f
    );
  }
  f = message.getEventGroupExcludesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      9,
      f
    );
  }
  f = message.getCollapseLimit();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getTagsIncludeList();
  if (f.length > 0) {
    writer.writePackedEnum(
      11,
      f
    );
  }
  f = message.getTagsExcludeList();
  if (f.length > 0) {
    writer.writePackedEnum(
      12,
      f
    );
  }
  f = message.getSortType();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
};


/**
 * repeated SalesChannel sales_channels = 1;
 * @return {!Array<!proto.buying.consumer_search.api.v1.SalesChannel>}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.getSalesChannelsList = function() {
  return /** @type {!Array<!proto.buying.consumer_search.api.v1.SalesChannel>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.SalesChannel>} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.setSalesChannelsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SalesChannel} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.addSalesChannels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.clearSalesChannelsList = function() {
  return this.setSalesChannelsList([]);
};


/**
 * repeated RecordType record_types = 2;
 * @return {!Array<!proto.buying.consumer_search.api.v1.RecordType>}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.getRecordTypesList = function() {
  return /** @type {!Array<!proto.buying.consumer_search.api.v1.RecordType>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.RecordType>} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.setRecordTypesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.RecordType} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.addRecordTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.clearRecordTypesList = function() {
  return this.setRecordTypesList([]);
};


/**
 * optional int64 page_limit = 3;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.getPageLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.setPageLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp event_time_after = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.getEventTimeAfter = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
*/
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.setEventTimeAfter = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.clearEventTimeAfter = function() {
  return this.setEventTimeAfter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.hasEventTimeAfter = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp event_time_before = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.getEventTimeBefore = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
*/
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.setEventTimeBefore = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.clearEventTimeBefore = function() {
  return this.setEventTimeBefore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.hasEventTimeBefore = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 page_number = 6;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional CollapseOn collapse_on = 7;
 * @return {!proto.buying.consumer_search.api.v1.CollapseOn}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.getCollapseOn = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.CollapseOn} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.CollapseOn} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.setCollapseOn = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * repeated EventGroup event_group_includes = 8;
 * @return {!Array<!proto.buying.consumer_search.api.v1.EventGroup>}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.getEventGroupIncludesList = function() {
  return /** @type {!Array<!proto.buying.consumer_search.api.v1.EventGroup>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.EventGroup>} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.setEventGroupIncludesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.EventGroup} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.addEventGroupIncludes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.clearEventGroupIncludesList = function() {
  return this.setEventGroupIncludesList([]);
};


/**
 * repeated EventGroup event_group_excludes = 9;
 * @return {!Array<!proto.buying.consumer_search.api.v1.EventGroup>}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.getEventGroupExcludesList = function() {
  return /** @type {!Array<!proto.buying.consumer_search.api.v1.EventGroup>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.EventGroup>} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.setEventGroupExcludesList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.EventGroup} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.addEventGroupExcludes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.clearEventGroupExcludesList = function() {
  return this.setEventGroupExcludesList([]);
};


/**
 * optional int64 collapse_limit = 10;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.getCollapseLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.setCollapseLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * repeated Tag tags_include = 11;
 * @return {!Array<!proto.buying.consumer_search.api.v1.Tag>}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.getTagsIncludeList = function() {
  return /** @type {!Array<!proto.buying.consumer_search.api.v1.Tag>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.Tag>} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.setTagsIncludeList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.Tag} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.addTagsInclude = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.clearTagsIncludeList = function() {
  return this.setTagsIncludeList([]);
};


/**
 * repeated Tag tags_exclude = 12;
 * @return {!Array<!proto.buying.consumer_search.api.v1.Tag>}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.getTagsExcludeList = function() {
  return /** @type {!Array<!proto.buying.consumer_search.api.v1.Tag>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.Tag>} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.setTagsExcludeList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.Tag} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.addTagsExclude = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.clearTagsExcludeList = function() {
  return this.setTagsExcludeList([]);
};


/**
 * optional EventSortType sort_type = 13;
 * @return {!proto.buying.consumer_search.api.v1.EventSortType}
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.getSortType = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.EventSortType} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.EventSortType} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchRequest.prototype.setSortType = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GiftShopProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GiftShopProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GiftShopProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GiftShopProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
articleSlug: jspb.Message.getFieldWithDefault(msg, 1, ""),
productImageUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
eventTime: (f = msg.getEventTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GiftShopProduct}
 */
proto.buying.consumer_search.api.v1.GiftShopProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GiftShopProduct;
  return proto.buying.consumer_search.api.v1.GiftShopProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GiftShopProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GiftShopProduct}
 */
proto.buying.consumer_search.api.v1.GiftShopProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArticleSlug(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductImageUrl(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEventTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GiftShopProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GiftShopProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GiftShopProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GiftShopProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArticleSlug();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProductImageUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEventTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string article_slug = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.GiftShopProduct.prototype.getArticleSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.GiftShopProduct} returns this
 */
proto.buying.consumer_search.api.v1.GiftShopProduct.prototype.setArticleSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string product_image_url = 2;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.GiftShopProduct.prototype.getProductImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.GiftShopProduct} returns this
 */
proto.buying.consumer_search.api.v1.GiftShopProduct.prototype.setProductImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp event_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.consumer_search.api.v1.GiftShopProduct.prototype.getEventTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.GiftShopProduct} returns this
*/
proto.buying.consumer_search.api.v1.GiftShopProduct.prototype.setEventTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.GiftShopProduct} returns this
 */
proto.buying.consumer_search.api.v1.GiftShopProduct.prototype.clearEventTime = function() {
  return this.setEventTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.GiftShopProduct.prototype.hasEventTime = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.ItemTypeCase = {
  ITEM_TYPE_NOT_SET: 0,
  AUCTION: 1,
  DROP: 2,
  TRIVIA: 3,
  GIFT_SHOP_PRODUCT: 4
};

/**
 * @return {proto.buying.consumer_search.api.v1.ServiceResultItem.ItemTypeCase}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.getItemTypeCase = function() {
  return /** @type {proto.buying.consumer_search.api.v1.ServiceResultItem.ItemTypeCase} */(jspb.Message.computeOneofCase(this, proto.buying.consumer_search.api.v1.ServiceResultItem.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.ServiceResultItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.ServiceResultItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.toObject = function(includeInstance, msg) {
  var f, obj = {
auction: (f = msg.getAuction()) && buying_auctions_api_v1_types_pb.UserAuction.toObject(includeInstance, f),
drop: (f = msg.getDrop()) && buying_drops_api_v1_types_pb.UserDrop.toObject(includeInstance, f),
trivia: (f = msg.getTrivia()) && buying_trivia_api_v1_types_pb.RedactedGameConfig.toObject(includeInstance, f),
giftShopProduct: (f = msg.getGiftShopProduct()) && proto.buying.consumer_search.api.v1.GiftShopProduct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.ServiceResultItem}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.ServiceResultItem;
  return proto.buying.consumer_search.api.v1.ServiceResultItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.ServiceResultItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.ServiceResultItem}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new buying_auctions_api_v1_types_pb.UserAuction;
      reader.readMessage(value,buying_auctions_api_v1_types_pb.UserAuction.deserializeBinaryFromReader);
      msg.setAuction(value);
      break;
    case 2:
      var value = new buying_drops_api_v1_types_pb.UserDrop;
      reader.readMessage(value,buying_drops_api_v1_types_pb.UserDrop.deserializeBinaryFromReader);
      msg.setDrop(value);
      break;
    case 3:
      var value = new buying_trivia_api_v1_types_pb.RedactedGameConfig;
      reader.readMessage(value,buying_trivia_api_v1_types_pb.RedactedGameConfig.deserializeBinaryFromReader);
      msg.setTrivia(value);
      break;
    case 4:
      var value = new proto.buying.consumer_search.api.v1.GiftShopProduct;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.GiftShopProduct.deserializeBinaryFromReader);
      msg.setGiftShopProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.ServiceResultItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.ServiceResultItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuction();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      buying_auctions_api_v1_types_pb.UserAuction.serializeBinaryToWriter
    );
  }
  f = message.getDrop();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      buying_drops_api_v1_types_pb.UserDrop.serializeBinaryToWriter
    );
  }
  f = message.getTrivia();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      buying_trivia_api_v1_types_pb.RedactedGameConfig.serializeBinaryToWriter
    );
  }
  f = message.getGiftShopProduct();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.buying.consumer_search.api.v1.GiftShopProduct.serializeBinaryToWriter
    );
  }
};


/**
 * optional buying.auctions.api.v1.UserAuction auction = 1;
 * @return {?proto.buying.auctions.api.v1.UserAuction}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.getAuction = function() {
  return /** @type{?proto.buying.auctions.api.v1.UserAuction} */ (
    jspb.Message.getWrapperField(this, buying_auctions_api_v1_types_pb.UserAuction, 1));
};


/**
 * @param {?proto.buying.auctions.api.v1.UserAuction|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.ServiceResultItem} returns this
*/
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.setAuction = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.buying.consumer_search.api.v1.ServiceResultItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.ServiceResultItem} returns this
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.clearAuction = function() {
  return this.setAuction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.hasAuction = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional goat.protos.buying.drops.api.v1.UserDrop drop = 2;
 * @return {?proto.goat.protos.buying.drops.api.v1.UserDrop}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.getDrop = function() {
  return /** @type{?proto.goat.protos.buying.drops.api.v1.UserDrop} */ (
    jspb.Message.getWrapperField(this, buying_drops_api_v1_types_pb.UserDrop, 2));
};


/**
 * @param {?proto.goat.protos.buying.drops.api.v1.UserDrop|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.ServiceResultItem} returns this
*/
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.setDrop = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.buying.consumer_search.api.v1.ServiceResultItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.ServiceResultItem} returns this
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.clearDrop = function() {
  return this.setDrop(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.hasDrop = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional buying.trivia.api.v1.RedactedGameConfig trivia = 3;
 * @return {?proto.buying.trivia.api.v1.RedactedGameConfig}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.getTrivia = function() {
  return /** @type{?proto.buying.trivia.api.v1.RedactedGameConfig} */ (
    jspb.Message.getWrapperField(this, buying_trivia_api_v1_types_pb.RedactedGameConfig, 3));
};


/**
 * @param {?proto.buying.trivia.api.v1.RedactedGameConfig|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.ServiceResultItem} returns this
*/
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.setTrivia = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.buying.consumer_search.api.v1.ServiceResultItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.ServiceResultItem} returns this
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.clearTrivia = function() {
  return this.setTrivia(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.hasTrivia = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional GiftShopProduct gift_shop_product = 4;
 * @return {?proto.buying.consumer_search.api.v1.GiftShopProduct}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.getGiftShopProduct = function() {
  return /** @type{?proto.buying.consumer_search.api.v1.GiftShopProduct} */ (
    jspb.Message.getWrapperField(this, proto.buying.consumer_search.api.v1.GiftShopProduct, 4));
};


/**
 * @param {?proto.buying.consumer_search.api.v1.GiftShopProduct|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.ServiceResultItem} returns this
*/
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.setGiftShopProduct = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.buying.consumer_search.api.v1.ServiceResultItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.ServiceResultItem} returns this
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.clearGiftShopProduct = function() {
  return this.setGiftShopProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.ServiceResultItem.prototype.hasGiftShopProduct = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.EventSearchResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.EventSearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.EventSearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.EventSearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.EventSearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
resultItemsList: jspb.Message.toObjectList(msg.getResultItemsList(),
    proto.buying.consumer_search.api.v1.ServiceResultItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.EventSearchResponse}
 */
proto.buying.consumer_search.api.v1.EventSearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.EventSearchResponse;
  return proto.buying.consumer_search.api.v1.EventSearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.EventSearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.EventSearchResponse}
 */
proto.buying.consumer_search.api.v1.EventSearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.buying.consumer_search.api.v1.ServiceResultItem;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.ServiceResultItem.deserializeBinaryFromReader);
      msg.addResultItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.EventSearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.EventSearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.EventSearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.EventSearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.buying.consumer_search.api.v1.ServiceResultItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ServiceResultItem result_items = 2;
 * @return {!Array<!proto.buying.consumer_search.api.v1.ServiceResultItem>}
 */
proto.buying.consumer_search.api.v1.EventSearchResponse.prototype.getResultItemsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.ServiceResultItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.ServiceResultItem, 2));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.ServiceResultItem>} value
 * @return {!proto.buying.consumer_search.api.v1.EventSearchResponse} returns this
*/
proto.buying.consumer_search.api.v1.EventSearchResponse.prototype.setResultItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.ServiceResultItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ServiceResultItem}
 */
proto.buying.consumer_search.api.v1.EventSearchResponse.prototype.addResultItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.buying.consumer_search.api.v1.ServiceResultItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.EventSearchResponse} returns this
 */
proto.buying.consumer_search.api.v1.EventSearchResponse.prototype.clearResultItemsList = function() {
  return this.setResultItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetProductsByIDRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetProductsByIDRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
salesChannelId: jspb.Message.getFieldWithDefault(msg, 1, 0),
productIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetProductsByIDRequest}
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetProductsByIDRequest;
  return proto.buying.consumer_search.api.v1.GetProductsByIDRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetProductsByIDRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetProductsByIDRequest}
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (reader.readEnum());
      msg.setSalesChannelId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addProductIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetProductsByIDRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetProductsByIDRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSalesChannelId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getProductIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional SalesChannel sales_channel_id = 1;
 * @return {!proto.buying.consumer_search.api.v1.SalesChannel}
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest.prototype.getSalesChannelId = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SalesChannel} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductsByIDRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest.prototype.setSalesChannelId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated string product_ids = 2;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest.prototype.getProductIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductsByIDRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest.prototype.setProductIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.GetProductsByIDRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest.prototype.addProductIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetProductsByIDRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductsByIDRequest.prototype.clearProductIdsList = function() {
  return this.setProductIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.Money.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.Money.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.Money} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.Money.toObject = function(includeInstance, msg) {
  var f, obj = {
amountCents: jspb.Message.getFieldWithDefault(msg, 1, 0),
currency: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.Money}
 */
proto.buying.consumer_search.api.v1.Money.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.Money;
  return proto.buying.consumer_search.api.v1.Money.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.Money} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.Money}
 */
proto.buying.consumer_search.api.v1.Money.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountCents(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.Money.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.Money.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.Money} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.Money.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 amount_cents = 1;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.Money.prototype.getAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.Money} returns this
 */
proto.buying.consumer_search.api.v1.Money.prototype.setAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Money.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Money} returns this
 */
proto.buying.consumer_search.api.v1.Money.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.Variant.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.Variant} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.Variant.toObject = function(includeInstance, msg) {
  var f, obj = {
productCondition: jspb.Message.getFieldWithDefault(msg, 1, 0),
lowestPriceCents: (f = msg.getLowestPriceCents()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
sizeUs: jspb.Message.getFieldWithDefault(msg, 3, ""),
localizedLowestPriceCents: (f = msg.getLocalizedLowestPriceCents()) && proto.buying.consumer_search.api.v1.Money.toObject(includeInstance, f),
productId: jspb.Message.getFieldWithDefault(msg, 5, ""),
retailPriceCents: (f = msg.getRetailPriceCents()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
localizedRetailPriceCents: (f = msg.getLocalizedRetailPriceCents()) && proto.buying.consumer_search.api.v1.Money.toObject(includeInstance, f),
size: (f = msg.getSize()) && proto.buying.consumer_search.api.v1.SizeFilter.toObject(includeInstance, f),
localizedInstantLowestPriceCents: (f = msg.getLocalizedInstantLowestPriceCents()) && proto.buying.consumer_search.api.v1.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.Variant}
 */
proto.buying.consumer_search.api.v1.Variant.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.Variant;
  return proto.buying.consumer_search.api.v1.Variant.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.Variant} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.Variant}
 */
proto.buying.consumer_search.api.v1.Variant.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.consumer_search.api.v1.ProductCondition} */ (reader.readEnum());
      msg.setProductCondition(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setLowestPriceCents(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSizeUs(value);
      break;
    case 4:
      var value = new proto.buying.consumer_search.api.v1.Money;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.Money.deserializeBinaryFromReader);
      msg.setLocalizedLowestPriceCents(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setRetailPriceCents(value);
      break;
    case 7:
      var value = new proto.buying.consumer_search.api.v1.Money;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.Money.deserializeBinaryFromReader);
      msg.setLocalizedRetailPriceCents(value);
      break;
    case 8:
      var value = new proto.buying.consumer_search.api.v1.SizeFilter;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.SizeFilter.deserializeBinaryFromReader);
      msg.setSize(value);
      break;
    case 9:
      var value = new proto.buying.consumer_search.api.v1.Money;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.Money.deserializeBinaryFromReader);
      msg.setLocalizedInstantLowestPriceCents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.Variant.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.Variant} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.Variant.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductCondition();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLowestPriceCents();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getSizeUs();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLocalizedLowestPriceCents();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.buying.consumer_search.api.v1.Money.serializeBinaryToWriter
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRetailPriceCents();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getLocalizedRetailPriceCents();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.buying.consumer_search.api.v1.Money.serializeBinaryToWriter
    );
  }
  f = message.getSize();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.buying.consumer_search.api.v1.SizeFilter.serializeBinaryToWriter
    );
  }
  f = message.getLocalizedInstantLowestPriceCents();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.buying.consumer_search.api.v1.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProductCondition product_condition = 1;
 * @return {!proto.buying.consumer_search.api.v1.ProductCondition}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.getProductCondition = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.ProductCondition} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.ProductCondition} value
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
 */
proto.buying.consumer_search.api.v1.Variant.prototype.setProductCondition = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional google.protobuf.Int64Value lowest_price_cents = 2;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.getLowestPriceCents = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
*/
proto.buying.consumer_search.api.v1.Variant.prototype.setLowestPriceCents = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
 */
proto.buying.consumer_search.api.v1.Variant.prototype.clearLowestPriceCents = function() {
  return this.setLowestPriceCents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.hasLowestPriceCents = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string size_us = 3;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.getSizeUs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
 */
proto.buying.consumer_search.api.v1.Variant.prototype.setSizeUs = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Money localized_lowest_price_cents = 4;
 * @return {?proto.buying.consumer_search.api.v1.Money}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.getLocalizedLowestPriceCents = function() {
  return /** @type{?proto.buying.consumer_search.api.v1.Money} */ (
    jspb.Message.getWrapperField(this, proto.buying.consumer_search.api.v1.Money, 4));
};


/**
 * @param {?proto.buying.consumer_search.api.v1.Money|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
*/
proto.buying.consumer_search.api.v1.Variant.prototype.setLocalizedLowestPriceCents = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
 */
proto.buying.consumer_search.api.v1.Variant.prototype.clearLocalizedLowestPriceCents = function() {
  return this.setLocalizedLowestPriceCents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.hasLocalizedLowestPriceCents = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string product_id = 5;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
 */
proto.buying.consumer_search.api.v1.Variant.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Int64Value retail_price_cents = 6;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.getRetailPriceCents = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 6));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
*/
proto.buying.consumer_search.api.v1.Variant.prototype.setRetailPriceCents = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
 */
proto.buying.consumer_search.api.v1.Variant.prototype.clearRetailPriceCents = function() {
  return this.setRetailPriceCents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.hasRetailPriceCents = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Money localized_retail_price_cents = 7;
 * @return {?proto.buying.consumer_search.api.v1.Money}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.getLocalizedRetailPriceCents = function() {
  return /** @type{?proto.buying.consumer_search.api.v1.Money} */ (
    jspb.Message.getWrapperField(this, proto.buying.consumer_search.api.v1.Money, 7));
};


/**
 * @param {?proto.buying.consumer_search.api.v1.Money|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
*/
proto.buying.consumer_search.api.v1.Variant.prototype.setLocalizedRetailPriceCents = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
 */
proto.buying.consumer_search.api.v1.Variant.prototype.clearLocalizedRetailPriceCents = function() {
  return this.setLocalizedRetailPriceCents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.hasLocalizedRetailPriceCents = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SizeFilter size = 8;
 * @return {?proto.buying.consumer_search.api.v1.SizeFilter}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.getSize = function() {
  return /** @type{?proto.buying.consumer_search.api.v1.SizeFilter} */ (
    jspb.Message.getWrapperField(this, proto.buying.consumer_search.api.v1.SizeFilter, 8));
};


/**
 * @param {?proto.buying.consumer_search.api.v1.SizeFilter|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
*/
proto.buying.consumer_search.api.v1.Variant.prototype.setSize = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
 */
proto.buying.consumer_search.api.v1.Variant.prototype.clearSize = function() {
  return this.setSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.hasSize = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Money localized_instant_lowest_price_cents = 9;
 * @return {?proto.buying.consumer_search.api.v1.Money}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.getLocalizedInstantLowestPriceCents = function() {
  return /** @type{?proto.buying.consumer_search.api.v1.Money} */ (
    jspb.Message.getWrapperField(this, proto.buying.consumer_search.api.v1.Money, 9));
};


/**
 * @param {?proto.buying.consumer_search.api.v1.Money|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
*/
proto.buying.consumer_search.api.v1.Variant.prototype.setLocalizedInstantLowestPriceCents = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.Variant} returns this
 */
proto.buying.consumer_search.api.v1.Variant.prototype.clearLocalizedInstantLowestPriceCents = function() {
  return this.setLocalizedInstantLowestPriceCents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.Variant.prototype.hasLocalizedInstantLowestPriceCents = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.Product.repeatedFields_ = [7,19];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.Product.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.Product.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.Product} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.Product.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getFieldWithDefault(msg, 2, ""),
slug: jspb.Message.getFieldWithDefault(msg, 3, ""),
title: jspb.Message.getFieldWithDefault(msg, 4, ""),
pictureUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
inStock: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
variantsList: jspb.Message.toObjectList(msg.getVariantsList(),
    proto.buying.consumer_search.api.v1.Variant.toObject, includeInstance),
retailPriceCents: (f = msg.getRetailPriceCents()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
releaseYear: jspb.Message.getFieldWithDefault(msg, 9, ""),
category: jspb.Message.getFieldWithDefault(msg, 10, ""),
seasonYear: jspb.Message.getFieldWithDefault(msg, 11, ""),
productType: jspb.Message.getFieldWithDefault(msg, 12, ""),
localizedRetailPriceCents: (f = msg.getLocalizedRetailPriceCents()) && proto.buying.consumer_search.api.v1.Money.toObject(includeInstance, f),
brandName: jspb.Message.getFieldWithDefault(msg, 14, ""),
activity: jspb.Message.getFieldWithDefault(msg, 15, ""),
seasonType: jspb.Message.getFieldWithDefault(msg, 16, ""),
underRetail: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
gender: jspb.Message.getFieldWithDefault(msg, 18, ""),
activitiesList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
releaseDate: (f = msg.getReleaseDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.Product}
 */
proto.buying.consumer_search.api.v1.Product.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.Product;
  return proto.buying.consumer_search.api.v1.Product.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.Product}
 */
proto.buying.consumer_search.api.v1.Product.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPictureUrl(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInStock(value);
      break;
    case 7:
      var value = new proto.buying.consumer_search.api.v1.Variant;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.Variant.deserializeBinaryFromReader);
      msg.addVariants(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setRetailPriceCents(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleaseYear(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeasonYear(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductType(value);
      break;
    case 13:
      var value = new proto.buying.consumer_search.api.v1.Money;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.Money.deserializeBinaryFromReader);
      msg.setLocalizedRetailPriceCents(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandName(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivity(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeasonType(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnderRetail(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setGender(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.addActivities(value);
      break;
    case 20:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setReleaseDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.Product.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.Product.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.Product.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPictureUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getInStock();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getVariantsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.buying.consumer_search.api.v1.Variant.serializeBinaryToWriter
    );
  }
  f = message.getRetailPriceCents();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getReleaseYear();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSeasonYear();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getProductType();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLocalizedRetailPriceCents();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.buying.consumer_search.api.v1.Money.serializeBinaryToWriter
    );
  }
  f = message.getBrandName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getActivity();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSeasonType();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getUnderRetail();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getGender();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getActivitiesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      19,
      f
    );
  }
  f = message.getReleaseDate();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slug = 3;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string picture_url = 5;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getPictureUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setPictureUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool in_stock = 6;
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getInStock = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setInStock = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * repeated Variant variants = 7;
 * @return {!Array<!proto.buying.consumer_search.api.v1.Variant>}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getVariantsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.Variant>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.Variant, 7));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.Variant>} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
*/
proto.buying.consumer_search.api.v1.Product.prototype.setVariantsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.Variant=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.Variant}
 */
proto.buying.consumer_search.api.v1.Product.prototype.addVariants = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.buying.consumer_search.api.v1.Variant, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.clearVariantsList = function() {
  return this.setVariantsList([]);
};


/**
 * optional google.protobuf.Int64Value retail_price_cents = 8;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getRetailPriceCents = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 8));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
*/
proto.buying.consumer_search.api.v1.Product.prototype.setRetailPriceCents = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.clearRetailPriceCents = function() {
  return this.setRetailPriceCents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.Product.prototype.hasRetailPriceCents = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string release_year = 9;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getReleaseYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setReleaseYear = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string category = 10;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string season_year = 11;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getSeasonYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setSeasonYear = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string product_type = 12;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getProductType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setProductType = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional Money localized_retail_price_cents = 13;
 * @return {?proto.buying.consumer_search.api.v1.Money}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getLocalizedRetailPriceCents = function() {
  return /** @type{?proto.buying.consumer_search.api.v1.Money} */ (
    jspb.Message.getWrapperField(this, proto.buying.consumer_search.api.v1.Money, 13));
};


/**
 * @param {?proto.buying.consumer_search.api.v1.Money|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
*/
proto.buying.consumer_search.api.v1.Product.prototype.setLocalizedRetailPriceCents = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.clearLocalizedRetailPriceCents = function() {
  return this.setLocalizedRetailPriceCents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.Product.prototype.hasLocalizedRetailPriceCents = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string brand_name = 14;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getBrandName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setBrandName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string activity = 15;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getActivity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setActivity = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string season_type = 16;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getSeasonType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setSeasonType = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional bool under_retail = 17;
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getUnderRetail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setUnderRetail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional string gender = 18;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getGender = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setGender = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * repeated string activities = 19;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getActivitiesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.setActivitiesList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.addActivities = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.clearActivitiesList = function() {
  return this.setActivitiesList([]);
};


/**
 * optional google.protobuf.Timestamp release_date = 20;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.consumer_search.api.v1.Product.prototype.getReleaseDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 20));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
*/
proto.buying.consumer_search.api.v1.Product.prototype.setReleaseDate = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.Product} returns this
 */
proto.buying.consumer_search.api.v1.Product.prototype.clearReleaseDate = function() {
  return this.setReleaseDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.Product.prototype.hasReleaseDate = function() {
  return jspb.Message.getField(this, 20) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.GetProductsByIDResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetProductsByIDResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetProductsByIDResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetProductsByIDResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductsByIDResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    proto.buying.consumer_search.api.v1.Product.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetProductsByIDResponse}
 */
proto.buying.consumer_search.api.v1.GetProductsByIDResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetProductsByIDResponse;
  return proto.buying.consumer_search.api.v1.GetProductsByIDResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetProductsByIDResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetProductsByIDResponse}
 */
proto.buying.consumer_search.api.v1.GetProductsByIDResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.consumer_search.api.v1.Product;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.Product.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetProductsByIDResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetProductsByIDResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetProductsByIDResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductsByIDResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.consumer_search.api.v1.Product.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Product products = 1;
 * @return {!Array<!proto.buying.consumer_search.api.v1.Product>}
 */
proto.buying.consumer_search.api.v1.GetProductsByIDResponse.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.Product>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.Product, 1));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.Product>} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductsByIDResponse} returns this
*/
proto.buying.consumer_search.api.v1.GetProductsByIDResponse.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.Product=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.Product}
 */
proto.buying.consumer_search.api.v1.GetProductsByIDResponse.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.consumer_search.api.v1.Product, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetProductsByIDResponse} returns this
 */
proto.buying.consumer_search.api.v1.GetProductsByIDResponse.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
salesChannel: jspb.Message.getFieldWithDefault(msg, 1, 0),
productId: jspb.Message.getFieldWithDefault(msg, 2, ""),
recordType: jspb.Message.getFieldWithDefault(msg, 3, 0),
pageLimit: jspb.Message.getFieldWithDefault(msg, 4, 0),
sortType: jspb.Message.getFieldWithDefault(msg, 5, 0),
tagsIncludeList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
tagsExcludeList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetRecordsForProductRequest;
  return proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (reader.readEnum());
      msg.setSalesChannel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 3:
      var value = /** @type {!proto.buying.consumer_search.api.v1.RecordType} */ (reader.readEnum());
      msg.setRecordType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPageLimit(value);
      break;
    case 5:
      var value = /** @type {!proto.buying.consumer_search.api.v1.ForProductSortType} */ (reader.readEnum());
      msg.setSortType(value);
      break;
    case 6:
      var values = /** @type {!Array<!proto.buying.consumer_search.api.v1.Tag>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addTagsInclude(values[i]);
      }
      break;
    case 7:
      var values = /** @type {!Array<!proto.buying.consumer_search.api.v1.Tag>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addTagsExclude(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSalesChannel();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRecordType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPageLimit();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getSortType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTagsIncludeList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
  f = message.getTagsExcludeList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
};


/**
 * optional SalesChannel sales_channel = 1;
 * @return {!proto.buying.consumer_search.api.v1.SalesChannel}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.getSalesChannel = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SalesChannel} value
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.setSalesChannel = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string product_id = 2;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional RecordType record_type = 3;
 * @return {!proto.buying.consumer_search.api.v1.RecordType}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.getRecordType = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.RecordType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.RecordType} value
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.setRecordType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 page_limit = 4;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.getPageLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.setPageLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional ForProductSortType sort_type = 5;
 * @return {!proto.buying.consumer_search.api.v1.ForProductSortType}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.getSortType = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.ForProductSortType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.ForProductSortType} value
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.setSortType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * repeated Tag tags_include = 6;
 * @return {!Array<!proto.buying.consumer_search.api.v1.Tag>}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.getTagsIncludeList = function() {
  return /** @type {!Array<!proto.buying.consumer_search.api.v1.Tag>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.Tag>} value
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.setTagsIncludeList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.Tag} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.addTagsInclude = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.clearTagsIncludeList = function() {
  return this.setTagsIncludeList([]);
};


/**
 * repeated Tag tags_exclude = 7;
 * @return {!Array<!proto.buying.consumer_search.api.v1.Tag>}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.getTagsExcludeList = function() {
  return /** @type {!Array<!proto.buying.consumer_search.api.v1.Tag>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.Tag>} value
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.setTagsExcludeList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.Tag} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.addTagsExclude = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductRequest.prototype.clearTagsExcludeList = function() {
  return this.setTagsExcludeList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetRecordsForProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
resultItemsList: jspb.Message.toObjectList(msg.getResultItemsList(),
    proto.buying.consumer_search.api.v1.ResultItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductResponse}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetRecordsForProductResponse;
  return proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetRecordsForProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductResponse}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.consumer_search.api.v1.ResultItem;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.ResultItem.deserializeBinaryFromReader);
      msg.addResultItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetRecordsForProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.consumer_search.api.v1.ResultItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ResultItem result_items = 1;
 * @return {!Array<!proto.buying.consumer_search.api.v1.ResultItem>}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.prototype.getResultItemsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.ResultItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.ResultItem, 1));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.ResultItem>} value
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductResponse} returns this
*/
proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.prototype.setResultItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.ResultItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ResultItem}
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.prototype.addResultItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.consumer_search.api.v1.ResultItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetRecordsForProductResponse} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordsForProductResponse.prototype.clearResultItemsList = function() {
  return this.setResultItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.SizeFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.SizeFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.SizeFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.SizeFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
productType: jspb.Message.getFieldWithDefault(msg, 1, 0),
gender: jspb.Message.getFieldWithDefault(msg, 2, 0),
sizeUnit: jspb.Message.getFieldWithDefault(msg, 3, 0),
size: jspb.Message.getFieldWithDefault(msg, 4, ""),
displayName: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.SizeFilter}
 */
proto.buying.consumer_search.api.v1.SizeFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.SizeFilter;
  return proto.buying.consumer_search.api.v1.SizeFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.SizeFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.SizeFilter}
 */
proto.buying.consumer_search.api.v1.SizeFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.consumer_search.api.v1.SizeFilterProductType} */ (reader.readEnum());
      msg.setProductType(value);
      break;
    case 2:
      var value = /** @type {!proto.buying.consumer_search.api.v1.SizeFilterGender} */ (reader.readEnum());
      msg.setGender(value);
      break;
    case 3:
      var value = /** @type {!proto.buying.consumer_search.api.v1.SizeFilterSizeUnit} */ (reader.readEnum());
      msg.setSizeUnit(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSize(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.SizeFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.SizeFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.SizeFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.SizeFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getGender();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSizeUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSize();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional SizeFilterProductType product_type = 1;
 * @return {!proto.buying.consumer_search.api.v1.SizeFilterProductType}
 */
proto.buying.consumer_search.api.v1.SizeFilter.prototype.getProductType = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.SizeFilterProductType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SizeFilterProductType} value
 * @return {!proto.buying.consumer_search.api.v1.SizeFilter} returns this
 */
proto.buying.consumer_search.api.v1.SizeFilter.prototype.setProductType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional SizeFilterGender gender = 2;
 * @return {!proto.buying.consumer_search.api.v1.SizeFilterGender}
 */
proto.buying.consumer_search.api.v1.SizeFilter.prototype.getGender = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.SizeFilterGender} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SizeFilterGender} value
 * @return {!proto.buying.consumer_search.api.v1.SizeFilter} returns this
 */
proto.buying.consumer_search.api.v1.SizeFilter.prototype.setGender = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional SizeFilterSizeUnit size_unit = 3;
 * @return {!proto.buying.consumer_search.api.v1.SizeFilterSizeUnit}
 */
proto.buying.consumer_search.api.v1.SizeFilter.prototype.getSizeUnit = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.SizeFilterSizeUnit} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SizeFilterSizeUnit} value
 * @return {!proto.buying.consumer_search.api.v1.SizeFilter} returns this
 */
proto.buying.consumer_search.api.v1.SizeFilter.prototype.setSizeUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string size = 4;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.SizeFilter.prototype.getSize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.SizeFilter} returns this
 */
proto.buying.consumer_search.api.v1.SizeFilter.prototype.setSize = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string display_name = 5;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.SizeFilter.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.SizeFilter} returns this
 */
proto.buying.consumer_search.api.v1.SizeFilter.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.ProductFilter.repeatedFields_ = [1,2,3,4,5,6,9,10,11,12,13,14,15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.ProductFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.ProductFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ProductFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
brandsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
categoriesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
colorsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
gendersList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
productTypesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
releaseYearsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
releaseDateStart: (f = msg.getReleaseDateStart()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
releaseDateEnd: (f = msg.getReleaseDateEnd()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
silhouettesList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
activitiesList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
productConditionsList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
sizesList: jspb.Message.toObjectList(msg.getSizesList(),
    proto.buying.consumer_search.api.v1.SizeFilter.toObject, includeInstance),
usSizesList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
designersList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
seasonsList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter}
 */
proto.buying.consumer_search.api.v1.ProductFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.ProductFilter;
  return proto.buying.consumer_search.api.v1.ProductFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.ProductFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter}
 */
proto.buying.consumer_search.api.v1.ProductFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addBrands(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategories(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addColors(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addGenders(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addProductTypes(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addReleaseYears(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setReleaseDateStart(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setReleaseDateEnd(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addSilhouettes(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addActivities(value);
      break;
    case 11:
      var values = /** @type {!Array<!proto.buying.consumer_search.api.v1.ProductCondition>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addProductConditions(values[i]);
      }
      break;
    case 12:
      var value = new proto.buying.consumer_search.api.v1.SizeFilter;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.SizeFilter.deserializeBinaryFromReader);
      msg.addSizes(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addUsSizes(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addDesigners(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.addSeasons(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.ProductFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.ProductFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ProductFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getColorsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getGendersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getProductTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getReleaseYearsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getReleaseDateStart();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getReleaseDateEnd();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSilhouettesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getActivitiesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getProductConditionsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      11,
      f
    );
  }
  f = message.getSizesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.buying.consumer_search.api.v1.SizeFilter.serializeBinaryToWriter
    );
  }
  f = message.getUsSizesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = message.getDesignersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
  f = message.getSeasonsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      15,
      f
    );
  }
};


/**
 * repeated string brands = 1;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getBrandsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setBrandsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.addBrands = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearBrandsList = function() {
  return this.setBrandsList([]);
};


/**
 * repeated string categories = 2;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setCategoriesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.addCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * repeated string colors = 3;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getColorsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setColorsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.addColors = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearColorsList = function() {
  return this.setColorsList([]);
};


/**
 * repeated string genders = 4;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getGendersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setGendersList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.addGenders = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearGendersList = function() {
  return this.setGendersList([]);
};


/**
 * repeated string product_types = 5;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getProductTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setProductTypesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.addProductTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearProductTypesList = function() {
  return this.setProductTypesList([]);
};


/**
 * repeated string release_years = 6;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getReleaseYearsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setReleaseYearsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.addReleaseYears = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearReleaseYearsList = function() {
  return this.setReleaseYearsList([]);
};


/**
 * optional google.protobuf.Timestamp release_date_start = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getReleaseDateStart = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
*/
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setReleaseDateStart = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearReleaseDateStart = function() {
  return this.setReleaseDateStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.hasReleaseDateStart = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp release_date_end = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getReleaseDateEnd = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
*/
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setReleaseDateEnd = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearReleaseDateEnd = function() {
  return this.setReleaseDateEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.hasReleaseDateEnd = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated string silhouettes = 9;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getSilhouettesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setSilhouettesList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.addSilhouettes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearSilhouettesList = function() {
  return this.setSilhouettesList([]);
};


/**
 * repeated string activities = 10;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getActivitiesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setActivitiesList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.addActivities = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearActivitiesList = function() {
  return this.setActivitiesList([]);
};


/**
 * repeated ProductCondition product_conditions = 11;
 * @return {!Array<!proto.buying.consumer_search.api.v1.ProductCondition>}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getProductConditionsList = function() {
  return /** @type {!Array<!proto.buying.consumer_search.api.v1.ProductCondition>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.ProductCondition>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setProductConditionsList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.ProductCondition} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.addProductConditions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearProductConditionsList = function() {
  return this.setProductConditionsList([]);
};


/**
 * repeated SizeFilter sizes = 12;
 * @return {!Array<!proto.buying.consumer_search.api.v1.SizeFilter>}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getSizesList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.SizeFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.SizeFilter, 12));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.SizeFilter>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
*/
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setSizesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SizeFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.SizeFilter}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.addSizes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.buying.consumer_search.api.v1.SizeFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearSizesList = function() {
  return this.setSizesList([]);
};


/**
 * repeated string us_sizes = 13;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getUsSizesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setUsSizesList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.addUsSizes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearUsSizesList = function() {
  return this.setUsSizesList([]);
};


/**
 * repeated string designers = 14;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getDesignersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setDesignersList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.addDesigners = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearDesignersList = function() {
  return this.setDesignersList([]);
};


/**
 * repeated string seasons = 15;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.getSeasonsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 15));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.setSeasonsList = function(value) {
  return jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.addSeasons = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductFilter.prototype.clearSeasonsList = function() {
  return this.setSeasonsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.repeatedFields_ = [14,17,18,19,22];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.ProductSearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.ProductSearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
queryString: jspb.Message.getFieldWithDefault(msg, 1, ""),
salesChannelId: jspb.Message.getFieldWithDefault(msg, 2, 0),
productFilter: (f = msg.getProductFilter()) && proto.buying.consumer_search.api.v1.ProductFilter.toObject(includeInstance, f),
sortType: jspb.Message.getFieldWithDefault(msg, 4, 0),
searchAfterProductId: jspb.Message.getFieldWithDefault(msg, 5, ""),
pageLimit: jspb.Message.getFieldWithDefault(msg, 6, 0),
pageNumber: jspb.Message.getFieldWithDefault(msg, 7, 0),
includeAggregations: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
includeVariants: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
collectionSlug: jspb.Message.getFieldWithDefault(msg, 10, ""),
priceCentsMin: jspb.Message.getFieldWithDefault(msg, 11, 0),
priceCentsMax: jspb.Message.getFieldWithDefault(msg, 12, 0),
includeVariantAggregations: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
similarityVectorList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 14)) == null ? undefined : f,
instantShip: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
underRetail: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
aggregationSizeUnitsList: (f = jspb.Message.getRepeatedField(msg, 17)) == null ? undefined : f,
excludeProductIdsList: (f = jspb.Message.getRepeatedField(msg, 18)) == null ? undefined : f,
aggregationsToIncludeList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
discountPercentageMin: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
discountPercentageMax: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0),
priceRangeCentsList: (f = jspb.Message.getRepeatedField(msg, 22)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.ProductSearchRequest;
  return proto.buying.consumer_search.api.v1.ProductSearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.ProductSearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQueryString(value);
      break;
    case 2:
      var value = /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (reader.readEnum());
      msg.setSalesChannelId(value);
      break;
    case 3:
      var value = new proto.buying.consumer_search.api.v1.ProductFilter;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.ProductFilter.deserializeBinaryFromReader);
      msg.setProductFilter(value);
      break;
    case 4:
      var value = /** @type {!proto.buying.consumer_search.api.v1.ProductSortType} */ (reader.readEnum());
      msg.setSortType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchAfterProductId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPageLimit(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPageNumber(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeAggregations(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeVariants(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCollectionSlug(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPriceCentsMin(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPriceCentsMax(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeVariantAggregations(value);
      break;
    case 14:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedDouble() : [reader.readDouble()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSimilarityVector(values[i]);
      }
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInstantShip(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnderRetail(value);
      break;
    case 17:
      var values = /** @type {!Array<!proto.buying.consumer_search.api.v1.SizeFilterSizeUnit>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAggregationSizeUnits(values[i]);
      }
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.addExcludeProductIds(value);
      break;
    case 19:
      var values = /** @type {!Array<!proto.buying.consumer_search.api.v1.Aggregation>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAggregationsToInclude(values[i]);
      }
      break;
    case 20:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDiscountPercentageMin(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDiscountPercentageMax(value);
      break;
    case 22:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPriceRangeCents(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.ProductSearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.ProductSearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQueryString();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSalesChannelId();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getProductFilter();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.buying.consumer_search.api.v1.ProductFilter.serializeBinaryToWriter
    );
  }
  f = message.getSortType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSearchAfterProductId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPageLimit();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getIncludeAggregations();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getIncludeVariants();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getCollectionSlug();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPriceCentsMin();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getPriceCentsMax();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getIncludeVariantAggregations();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getSimilarityVectorList();
  if (f.length > 0) {
    writer.writePackedDouble(
      14,
      f
    );
  }
  f = message.getInstantShip();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getUnderRetail();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getAggregationSizeUnitsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      17,
      f
    );
  }
  f = message.getExcludeProductIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      18,
      f
    );
  }
  f = message.getAggregationsToIncludeList();
  if (f.length > 0) {
    writer.writePackedEnum(
      19,
      f
    );
  }
  f = message.getDiscountPercentageMin();
  if (f !== 0.0) {
    writer.writeFloat(
      20,
      f
    );
  }
  f = message.getDiscountPercentageMax();
  if (f !== 0.0) {
    writer.writeFloat(
      21,
      f
    );
  }
  f = message.getPriceRangeCentsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      22,
      f
    );
  }
};


/**
 * optional string query_string = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getQueryString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setQueryString = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SalesChannel sales_channel_id = 2;
 * @return {!proto.buying.consumer_search.api.v1.SalesChannel}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getSalesChannelId = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SalesChannel} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setSalesChannelId = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ProductFilter product_filter = 3;
 * @return {?proto.buying.consumer_search.api.v1.ProductFilter}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getProductFilter = function() {
  return /** @type{?proto.buying.consumer_search.api.v1.ProductFilter} */ (
    jspb.Message.getWrapperField(this, proto.buying.consumer_search.api.v1.ProductFilter, 3));
};


/**
 * @param {?proto.buying.consumer_search.api.v1.ProductFilter|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
*/
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setProductFilter = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.clearProductFilter = function() {
  return this.setProductFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.hasProductFilter = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ProductSortType sort_type = 4;
 * @return {!proto.buying.consumer_search.api.v1.ProductSortType}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getSortType = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.ProductSortType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.ProductSortType} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setSortType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string search_after_product_id = 5;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getSearchAfterProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setSearchAfterProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 page_limit = 6;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getPageLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setPageLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 page_number = 7;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool include_aggregations = 8;
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getIncludeAggregations = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setIncludeAggregations = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool include_variants = 9;
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getIncludeVariants = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setIncludeVariants = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional string collection_slug = 10;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getCollectionSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setCollectionSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 price_cents_min = 11;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getPriceCentsMin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setPriceCentsMin = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 price_cents_max = 12;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getPriceCentsMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setPriceCentsMax = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional bool include_variant_aggregations = 13;
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getIncludeVariantAggregations = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setIncludeVariantAggregations = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * repeated double similarity_vector = 14;
 * @return {!Array<number>}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getSimilarityVectorList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 14));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setSimilarityVectorList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.addSimilarityVector = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.clearSimilarityVectorList = function() {
  return this.setSimilarityVectorList([]);
};


/**
 * optional bool instant_ship = 15;
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getInstantShip = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setInstantShip = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool under_retail = 16;
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getUnderRetail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setUnderRetail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * repeated SizeFilterSizeUnit aggregation_size_units = 17;
 * @return {!Array<!proto.buying.consumer_search.api.v1.SizeFilterSizeUnit>}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getAggregationSizeUnitsList = function() {
  return /** @type {!Array<!proto.buying.consumer_search.api.v1.SizeFilterSizeUnit>} */ (jspb.Message.getRepeatedField(this, 17));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.SizeFilterSizeUnit>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setAggregationSizeUnitsList = function(value) {
  return jspb.Message.setField(this, 17, value || []);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SizeFilterSizeUnit} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.addAggregationSizeUnits = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.clearAggregationSizeUnitsList = function() {
  return this.setAggregationSizeUnitsList([]);
};


/**
 * repeated string exclude_product_ids = 18;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getExcludeProductIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 18));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setExcludeProductIdsList = function(value) {
  return jspb.Message.setField(this, 18, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.addExcludeProductIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 18, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.clearExcludeProductIdsList = function() {
  return this.setExcludeProductIdsList([]);
};


/**
 * repeated Aggregation aggregations_to_include = 19;
 * @return {!Array<!proto.buying.consumer_search.api.v1.Aggregation>}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getAggregationsToIncludeList = function() {
  return /** @type {!Array<!proto.buying.consumer_search.api.v1.Aggregation>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.Aggregation>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setAggregationsToIncludeList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.Aggregation} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.addAggregationsToInclude = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.clearAggregationsToIncludeList = function() {
  return this.setAggregationsToIncludeList([]);
};


/**
 * optional float discount_percentage_min = 20;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getDiscountPercentageMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setDiscountPercentageMin = function(value) {
  return jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional float discount_percentage_max = 21;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getDiscountPercentageMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setDiscountPercentageMax = function(value) {
  return jspb.Message.setProto3FloatField(this, 21, value);
};


/**
 * repeated int64 price_range_cents = 22;
 * @return {!Array<number>}
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.getPriceRangeCentsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 22));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.setPriceRangeCentsList = function(value) {
  return jspb.Message.setField(this, 22, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.addPriceRangeCents = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 22, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchRequest} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchRequest.prototype.clearPriceRangeCentsList = function() {
  return this.setPriceRangeCentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.FilterDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.FilterDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.FilterDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.FilterDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
count: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.FilterDetail}
 */
proto.buying.consumer_search.api.v1.FilterDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.FilterDetail;
  return proto.buying.consumer_search.api.v1.FilterDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.FilterDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.FilterDetail}
 */
proto.buying.consumer_search.api.v1.FilterDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.FilterDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.FilterDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.FilterDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.FilterDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.FilterDetail.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.FilterDetail} returns this
 */
proto.buying.consumer_search.api.v1.FilterDetail.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 count = 2;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.FilterDetail.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.FilterDetail} returns this
 */
proto.buying.consumer_search.api.v1.FilterDetail.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.ActivityFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.ActivityFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.ActivityFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ActivityFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
count: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.ActivityFilter}
 */
proto.buying.consumer_search.api.v1.ActivityFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.ActivityFilter;
  return proto.buying.consumer_search.api.v1.ActivityFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.ActivityFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.ActivityFilter}
 */
proto.buying.consumer_search.api.v1.ActivityFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.ActivityFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.ActivityFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.ActivityFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ActivityFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ActivityFilter.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ActivityFilter} returns this
 */
proto.buying.consumer_search.api.v1.ActivityFilter.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 count = 2;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.ActivityFilter.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.ActivityFilter} returns this
 */
proto.buying.consumer_search.api.v1.ActivityFilter.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.ProductTypeFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.ProductTypeFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
count: jspb.Message.getFieldWithDefault(msg, 2, 0),
activitiesList: jspb.Message.toObjectList(msg.getActivitiesList(),
    proto.buying.consumer_search.api.v1.ActivityFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.ProductTypeFilter}
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.ProductTypeFilter;
  return proto.buying.consumer_search.api.v1.ProductTypeFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.ProductTypeFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.ProductTypeFilter}
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    case 3:
      var value = new proto.buying.consumer_search.api.v1.ActivityFilter;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.ActivityFilter.deserializeBinaryFromReader);
      msg.addActivities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.ProductTypeFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.ProductTypeFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getActivitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.buying.consumer_search.api.v1.ActivityFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ProductTypeFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 count = 2;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.ProductTypeFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated ActivityFilter activities = 3;
 * @return {!Array<!proto.buying.consumer_search.api.v1.ActivityFilter>}
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.prototype.getActivitiesList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.ActivityFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.ActivityFilter, 3));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.ActivityFilter>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductTypeFilter} returns this
*/
proto.buying.consumer_search.api.v1.ProductTypeFilter.prototype.setActivitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.ActivityFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ActivityFilter}
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.prototype.addActivities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.buying.consumer_search.api.v1.ActivityFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductTypeFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductTypeFilter.prototype.clearActivitiesList = function() {
  return this.setActivitiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.ProductCategoryFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.ProductCategoryFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
count: jspb.Message.getFieldWithDefault(msg, 2, 0),
productTypesList: jspb.Message.toObjectList(msg.getProductTypesList(),
    proto.buying.consumer_search.api.v1.ProductTypeFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.ProductCategoryFilter}
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.ProductCategoryFilter;
  return proto.buying.consumer_search.api.v1.ProductCategoryFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.ProductCategoryFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.ProductCategoryFilter}
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    case 3:
      var value = new proto.buying.consumer_search.api.v1.ProductTypeFilter;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.ProductTypeFilter.deserializeBinaryFromReader);
      msg.addProductTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.ProductCategoryFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.ProductCategoryFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getProductTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.buying.consumer_search.api.v1.ProductTypeFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.ProductCategoryFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 count = 2;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.ProductCategoryFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated ProductTypeFilter product_types = 3;
 * @return {!Array<!proto.buying.consumer_search.api.v1.ProductTypeFilter>}
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.prototype.getProductTypesList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.ProductTypeFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.ProductTypeFilter, 3));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.ProductTypeFilter>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductCategoryFilter} returns this
*/
proto.buying.consumer_search.api.v1.ProductCategoryFilter.prototype.setProductTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.ProductTypeFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductTypeFilter}
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.prototype.addProductTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.buying.consumer_search.api.v1.ProductTypeFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductCategoryFilter} returns this
 */
proto.buying.consumer_search.api.v1.ProductCategoryFilter.prototype.clearProductTypesList = function() {
  return this.setProductTypesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.SizeFilterDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.SizeFilterDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
count: jspb.Message.getFieldWithDefault(msg, 2, 0),
gendersList: jspb.Message.toObjectList(msg.getGendersList(),
    proto.buying.consumer_search.api.v1.AvailableGenderFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.SizeFilterDetail}
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.SizeFilterDetail;
  return proto.buying.consumer_search.api.v1.SizeFilterDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.SizeFilterDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.SizeFilterDetail}
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    case 3:
      var value = new proto.buying.consumer_search.api.v1.AvailableGenderFilter;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.AvailableGenderFilter.deserializeBinaryFromReader);
      msg.addGenders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.SizeFilterDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.SizeFilterDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getGendersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.buying.consumer_search.api.v1.AvailableGenderFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.SizeFilterDetail} returns this
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 count = 2;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.SizeFilterDetail} returns this
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated AvailableGenderFilter genders = 3;
 * @return {!Array<!proto.buying.consumer_search.api.v1.AvailableGenderFilter>}
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.prototype.getGendersList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.AvailableGenderFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.AvailableGenderFilter, 3));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.AvailableGenderFilter>} value
 * @return {!proto.buying.consumer_search.api.v1.SizeFilterDetail} returns this
*/
proto.buying.consumer_search.api.v1.SizeFilterDetail.prototype.setGendersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.AvailableGenderFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.AvailableGenderFilter}
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.prototype.addGenders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.buying.consumer_search.api.v1.AvailableGenderFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.SizeFilterDetail} returns this
 */
proto.buying.consumer_search.api.v1.SizeFilterDetail.prototype.clearGendersList = function() {
  return this.setGendersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.AvailableGenderFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.AvailableGenderFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
count: jspb.Message.getFieldWithDefault(msg, 2, 0),
availableSizesList: jspb.Message.toObjectList(msg.getAvailableSizesList(),
    proto.buying.consumer_search.api.v1.AvailableSizeFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.AvailableGenderFilter}
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.AvailableGenderFilter;
  return proto.buying.consumer_search.api.v1.AvailableGenderFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.AvailableGenderFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.AvailableGenderFilter}
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    case 3:
      var value = new proto.buying.consumer_search.api.v1.AvailableSizeFilter;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.AvailableSizeFilter.deserializeBinaryFromReader);
      msg.addAvailableSizes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.AvailableGenderFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.AvailableGenderFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAvailableSizesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.buying.consumer_search.api.v1.AvailableSizeFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableGenderFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 count = 2;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableGenderFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated AvailableSizeFilter available_sizes = 3;
 * @return {!Array<!proto.buying.consumer_search.api.v1.AvailableSizeFilter>}
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.prototype.getAvailableSizesList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.AvailableSizeFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.AvailableSizeFilter, 3));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.AvailableSizeFilter>} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableGenderFilter} returns this
*/
proto.buying.consumer_search.api.v1.AvailableGenderFilter.prototype.setAvailableSizesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.AvailableSizeFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.AvailableSizeFilter}
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.prototype.addAvailableSizes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.buying.consumer_search.api.v1.AvailableSizeFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AvailableGenderFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableGenderFilter.prototype.clearAvailableSizesList = function() {
  return this.setAvailableSizesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.AvailableSizeFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.AvailableSizeFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.AvailableSizeFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.AvailableSizeFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
count: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.AvailableSizeFilter}
 */
proto.buying.consumer_search.api.v1.AvailableSizeFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.AvailableSizeFilter;
  return proto.buying.consumer_search.api.v1.AvailableSizeFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.AvailableSizeFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.AvailableSizeFilter}
 */
proto.buying.consumer_search.api.v1.AvailableSizeFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.AvailableSizeFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.AvailableSizeFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.AvailableSizeFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.AvailableSizeFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.AvailableSizeFilter.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableSizeFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableSizeFilter.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 count = 2;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.AvailableSizeFilter.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableSizeFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableSizeFilter.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.AvailableFilter.repeatedFields_ = [1,2,3,4,5,8,9,10,11,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.AvailableFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.AvailableFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.AvailableFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
brandsList: jspb.Message.toObjectList(msg.getBrandsList(),
    proto.buying.consumer_search.api.v1.FilterDetail.toObject, includeInstance),
colorsList: jspb.Message.toObjectList(msg.getColorsList(),
    proto.buying.consumer_search.api.v1.FilterDetail.toObject, includeInstance),
gendersList: jspb.Message.toObjectList(msg.getGendersList(),
    proto.buying.consumer_search.api.v1.FilterDetail.toObject, includeInstance),
releaseYearsList: jspb.Message.toObjectList(msg.getReleaseYearsList(),
    proto.buying.consumer_search.api.v1.FilterDetail.toObject, includeInstance),
productCategoriesList: jspb.Message.toObjectList(msg.getProductCategoriesList(),
    proto.buying.consumer_search.api.v1.ProductCategoryFilter.toObject, includeInstance),
minimumPriceCents: (f = msg.getMinimumPriceCents()) && proto.buying.consumer_search.api.v1.Money.toObject(includeInstance, f),
maximumPriceCents: (f = msg.getMaximumPriceCents()) && proto.buying.consumer_search.api.v1.Money.toObject(includeInstance, f),
productConditionsList: jspb.Message.toObjectList(msg.getProductConditionsList(),
    proto.buying.consumer_search.api.v1.FilterDetail.toObject, includeInstance),
sizesList: jspb.Message.toObjectList(msg.getSizesList(),
    proto.buying.consumer_search.api.v1.SizeFilterDetail.toObject, includeInstance),
silhouettesList: jspb.Message.toObjectList(msg.getSilhouettesList(),
    proto.buying.consumer_search.api.v1.FilterDetail.toObject, includeInstance),
designersList: jspb.Message.toObjectList(msg.getDesignersList(),
    proto.buying.consumer_search.api.v1.FilterDetail.toObject, includeInstance),
seasonsList: jspb.Message.toObjectList(msg.getSeasonsList(),
    proto.buying.consumer_search.api.v1.FilterDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.AvailableFilter;
  return proto.buying.consumer_search.api.v1.AvailableFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.AvailableFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.consumer_search.api.v1.FilterDetail;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.FilterDetail.deserializeBinaryFromReader);
      msg.addBrands(value);
      break;
    case 2:
      var value = new proto.buying.consumer_search.api.v1.FilterDetail;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.FilterDetail.deserializeBinaryFromReader);
      msg.addColors(value);
      break;
    case 3:
      var value = new proto.buying.consumer_search.api.v1.FilterDetail;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.FilterDetail.deserializeBinaryFromReader);
      msg.addGenders(value);
      break;
    case 4:
      var value = new proto.buying.consumer_search.api.v1.FilterDetail;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.FilterDetail.deserializeBinaryFromReader);
      msg.addReleaseYears(value);
      break;
    case 5:
      var value = new proto.buying.consumer_search.api.v1.ProductCategoryFilter;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.ProductCategoryFilter.deserializeBinaryFromReader);
      msg.addProductCategories(value);
      break;
    case 6:
      var value = new proto.buying.consumer_search.api.v1.Money;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.Money.deserializeBinaryFromReader);
      msg.setMinimumPriceCents(value);
      break;
    case 7:
      var value = new proto.buying.consumer_search.api.v1.Money;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.Money.deserializeBinaryFromReader);
      msg.setMaximumPriceCents(value);
      break;
    case 8:
      var value = new proto.buying.consumer_search.api.v1.FilterDetail;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.FilterDetail.deserializeBinaryFromReader);
      msg.addProductConditions(value);
      break;
    case 9:
      var value = new proto.buying.consumer_search.api.v1.SizeFilterDetail;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.SizeFilterDetail.deserializeBinaryFromReader);
      msg.addSizes(value);
      break;
    case 10:
      var value = new proto.buying.consumer_search.api.v1.FilterDetail;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.FilterDetail.deserializeBinaryFromReader);
      msg.addSilhouettes(value);
      break;
    case 11:
      var value = new proto.buying.consumer_search.api.v1.FilterDetail;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.FilterDetail.deserializeBinaryFromReader);
      msg.addDesigners(value);
      break;
    case 12:
      var value = new proto.buying.consumer_search.api.v1.FilterDetail;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.FilterDetail.deserializeBinaryFromReader);
      msg.addSeasons(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.AvailableFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.AvailableFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.AvailableFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.consumer_search.api.v1.FilterDetail.serializeBinaryToWriter
    );
  }
  f = message.getColorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.buying.consumer_search.api.v1.FilterDetail.serializeBinaryToWriter
    );
  }
  f = message.getGendersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.buying.consumer_search.api.v1.FilterDetail.serializeBinaryToWriter
    );
  }
  f = message.getReleaseYearsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.buying.consumer_search.api.v1.FilterDetail.serializeBinaryToWriter
    );
  }
  f = message.getProductCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.buying.consumer_search.api.v1.ProductCategoryFilter.serializeBinaryToWriter
    );
  }
  f = message.getMinimumPriceCents();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.buying.consumer_search.api.v1.Money.serializeBinaryToWriter
    );
  }
  f = message.getMaximumPriceCents();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.buying.consumer_search.api.v1.Money.serializeBinaryToWriter
    );
  }
  f = message.getProductConditionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.buying.consumer_search.api.v1.FilterDetail.serializeBinaryToWriter
    );
  }
  f = message.getSizesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.buying.consumer_search.api.v1.SizeFilterDetail.serializeBinaryToWriter
    );
  }
  f = message.getSilhouettesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.buying.consumer_search.api.v1.FilterDetail.serializeBinaryToWriter
    );
  }
  f = message.getDesignersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.buying.consumer_search.api.v1.FilterDetail.serializeBinaryToWriter
    );
  }
  f = message.getSeasonsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.buying.consumer_search.api.v1.FilterDetail.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FilterDetail brands = 1;
 * @return {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.getBrandsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.FilterDetail, 1));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
*/
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.setBrandsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.FilterDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.FilterDetail}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.addBrands = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.consumer_search.api.v1.FilterDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.clearBrandsList = function() {
  return this.setBrandsList([]);
};


/**
 * repeated FilterDetail colors = 2;
 * @return {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.getColorsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.FilterDetail, 2));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
*/
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.setColorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.FilterDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.FilterDetail}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.addColors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.buying.consumer_search.api.v1.FilterDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.clearColorsList = function() {
  return this.setColorsList([]);
};


/**
 * repeated FilterDetail genders = 3;
 * @return {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.getGendersList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.FilterDetail, 3));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
*/
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.setGendersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.FilterDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.FilterDetail}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.addGenders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.buying.consumer_search.api.v1.FilterDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.clearGendersList = function() {
  return this.setGendersList([]);
};


/**
 * repeated FilterDetail release_years = 4;
 * @return {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.getReleaseYearsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.FilterDetail, 4));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
*/
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.setReleaseYearsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.FilterDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.FilterDetail}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.addReleaseYears = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.buying.consumer_search.api.v1.FilterDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.clearReleaseYearsList = function() {
  return this.setReleaseYearsList([]);
};


/**
 * repeated ProductCategoryFilter product_categories = 5;
 * @return {!Array<!proto.buying.consumer_search.api.v1.ProductCategoryFilter>}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.getProductCategoriesList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.ProductCategoryFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.ProductCategoryFilter, 5));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.ProductCategoryFilter>} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
*/
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.setProductCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.ProductCategoryFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.ProductCategoryFilter}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.addProductCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.buying.consumer_search.api.v1.ProductCategoryFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.clearProductCategoriesList = function() {
  return this.setProductCategoriesList([]);
};


/**
 * optional Money minimum_price_cents = 6;
 * @return {?proto.buying.consumer_search.api.v1.Money}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.getMinimumPriceCents = function() {
  return /** @type{?proto.buying.consumer_search.api.v1.Money} */ (
    jspb.Message.getWrapperField(this, proto.buying.consumer_search.api.v1.Money, 6));
};


/**
 * @param {?proto.buying.consumer_search.api.v1.Money|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
*/
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.setMinimumPriceCents = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.clearMinimumPriceCents = function() {
  return this.setMinimumPriceCents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.hasMinimumPriceCents = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Money maximum_price_cents = 7;
 * @return {?proto.buying.consumer_search.api.v1.Money}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.getMaximumPriceCents = function() {
  return /** @type{?proto.buying.consumer_search.api.v1.Money} */ (
    jspb.Message.getWrapperField(this, proto.buying.consumer_search.api.v1.Money, 7));
};


/**
 * @param {?proto.buying.consumer_search.api.v1.Money|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
*/
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.setMaximumPriceCents = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.clearMaximumPriceCents = function() {
  return this.setMaximumPriceCents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.hasMaximumPriceCents = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated FilterDetail product_conditions = 8;
 * @return {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.getProductConditionsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.FilterDetail, 8));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
*/
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.setProductConditionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.FilterDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.FilterDetail}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.addProductConditions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.buying.consumer_search.api.v1.FilterDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.clearProductConditionsList = function() {
  return this.setProductConditionsList([]);
};


/**
 * repeated SizeFilterDetail sizes = 9;
 * @return {!Array<!proto.buying.consumer_search.api.v1.SizeFilterDetail>}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.getSizesList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.SizeFilterDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.SizeFilterDetail, 9));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.SizeFilterDetail>} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
*/
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.setSizesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SizeFilterDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.SizeFilterDetail}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.addSizes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.buying.consumer_search.api.v1.SizeFilterDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.clearSizesList = function() {
  return this.setSizesList([]);
};


/**
 * repeated FilterDetail silhouettes = 10;
 * @return {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.getSilhouettesList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.FilterDetail, 10));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
*/
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.setSilhouettesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.FilterDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.FilterDetail}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.addSilhouettes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.buying.consumer_search.api.v1.FilterDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.clearSilhouettesList = function() {
  return this.setSilhouettesList([]);
};


/**
 * repeated FilterDetail designers = 11;
 * @return {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.getDesignersList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.FilterDetail, 11));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
*/
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.setDesignersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.FilterDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.FilterDetail}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.addDesigners = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.buying.consumer_search.api.v1.FilterDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.clearDesignersList = function() {
  return this.setDesignersList([]);
};


/**
 * repeated FilterDetail seasons = 12;
 * @return {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.getSeasonsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.FilterDetail, 12));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.FilterDetail>} value
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
*/
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.setSeasonsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.FilterDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.FilterDetail}
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.addSeasons = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.buying.consumer_search.api.v1.FilterDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AvailableFilter} returns this
 */
proto.buying.consumer_search.api.v1.AvailableFilter.prototype.clearSeasonsList = function() {
  return this.setSeasonsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.ProductSearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.ProductSearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
totalResults: jspb.Message.getFieldWithDefault(msg, 1, 0),
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    proto.buying.consumer_search.api.v1.Product.toObject, includeInstance),
availableFilters: (f = msg.getAvailableFilters()) && proto.buying.consumer_search.api.v1.AvailableFilter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchResponse}
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.ProductSearchResponse;
  return proto.buying.consumer_search.api.v1.ProductSearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.ProductSearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchResponse}
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalResults(value);
      break;
    case 2:
      var value = new proto.buying.consumer_search.api.v1.Product;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.Product.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 3:
      var value = new proto.buying.consumer_search.api.v1.AvailableFilter;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.AvailableFilter.deserializeBinaryFromReader);
      msg.setAvailableFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.ProductSearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.ProductSearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalResults();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.buying.consumer_search.api.v1.Product.serializeBinaryToWriter
    );
  }
  f = message.getAvailableFilters();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.buying.consumer_search.api.v1.AvailableFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 total_results = 1;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.prototype.getTotalResults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchResponse} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.prototype.setTotalResults = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated Product products = 2;
 * @return {!Array<!proto.buying.consumer_search.api.v1.Product>}
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.Product>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.Product, 2));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.Product>} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchResponse} returns this
*/
proto.buying.consumer_search.api.v1.ProductSearchResponse.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.Product=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.Product}
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.buying.consumer_search.api.v1.Product, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchResponse} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * optional AvailableFilter available_filters = 3;
 * @return {?proto.buying.consumer_search.api.v1.AvailableFilter}
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.prototype.getAvailableFilters = function() {
  return /** @type{?proto.buying.consumer_search.api.v1.AvailableFilter} */ (
    jspb.Message.getWrapperField(this, proto.buying.consumer_search.api.v1.AvailableFilter, 3));
};


/**
 * @param {?proto.buying.consumer_search.api.v1.AvailableFilter|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchResponse} returns this
*/
proto.buying.consumer_search.api.v1.ProductSearchResponse.prototype.setAvailableFilters = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.ProductSearchResponse} returns this
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.prototype.clearAvailableFilters = function() {
  return this.setAvailableFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.ProductSearchResponse.prototype.hasAvailableFilters = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.AggregationBucket.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.AggregationBucket.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.AggregationBucket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.AggregationBucket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.AggregationBucket.toObject = function(includeInstance, msg) {
  var f, obj = {
bucketName: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
field: jspb.Message.getFieldWithDefault(msg, 3, 0),
childrenList: jspb.Message.toObjectList(msg.getChildrenList(),
    proto.buying.consumer_search.api.v1.AggregationBucket.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucket}
 */
proto.buying.consumer_search.api.v1.AggregationBucket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.AggregationBucket;
  return proto.buying.consumer_search.api.v1.AggregationBucket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.AggregationBucket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucket}
 */
proto.buying.consumer_search.api.v1.AggregationBucket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBucketName(value);
      break;
    case 2:
      var value = /** @type {!proto.buying.consumer_search.api.v1.AggregationType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {!proto.buying.consumer_search.api.v1.AggregationField} */ (reader.readEnum());
      msg.setField(value);
      break;
    case 4:
      var value = new proto.buying.consumer_search.api.v1.AggregationBucket;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.AggregationBucket.deserializeBinaryFromReader);
      msg.addChildren(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.AggregationBucket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.AggregationBucket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.AggregationBucket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.AggregationBucket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucketName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getField();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.buying.consumer_search.api.v1.AggregationBucket.serializeBinaryToWriter
    );
  }
};


/**
 * optional string bucket_name = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.AggregationBucket.prototype.getBucketName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucket} returns this
 */
proto.buying.consumer_search.api.v1.AggregationBucket.prototype.setBucketName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AggregationType type = 2;
 * @return {!proto.buying.consumer_search.api.v1.AggregationType}
 */
proto.buying.consumer_search.api.v1.AggregationBucket.prototype.getType = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.AggregationType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.AggregationType} value
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucket} returns this
 */
proto.buying.consumer_search.api.v1.AggregationBucket.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional AggregationField field = 3;
 * @return {!proto.buying.consumer_search.api.v1.AggregationField}
 */
proto.buying.consumer_search.api.v1.AggregationBucket.prototype.getField = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.AggregationField} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.AggregationField} value
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucket} returns this
 */
proto.buying.consumer_search.api.v1.AggregationBucket.prototype.setField = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated AggregationBucket children = 4;
 * @return {!Array<!proto.buying.consumer_search.api.v1.AggregationBucket>}
 */
proto.buying.consumer_search.api.v1.AggregationBucket.prototype.getChildrenList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.AggregationBucket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.AggregationBucket, 4));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.AggregationBucket>} value
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucket} returns this
*/
proto.buying.consumer_search.api.v1.AggregationBucket.prototype.setChildrenList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.AggregationBucket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucket}
 */
proto.buying.consumer_search.api.v1.AggregationBucket.prototype.addChildren = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.buying.consumer_search.api.v1.AggregationBucket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucket} returns this
 */
proto.buying.consumer_search.api.v1.AggregationBucket.prototype.clearChildrenList = function() {
  return this.setChildrenList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetProductAggregationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
salesChannel: jspb.Message.getFieldWithDefault(msg, 1, 0),
bucketsList: jspb.Message.toObjectList(msg.getBucketsList(),
    proto.buying.consumer_search.api.v1.AggregationBucket.toObject, includeInstance),
activatedAtAfter: (f = msg.getActivatedAtAfter()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
activatedAtBefore: (f = msg.getActivatedAtBefore()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAggregationsRequest}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetProductAggregationsRequest;
  return proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetProductAggregationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAggregationsRequest}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (reader.readEnum());
      msg.setSalesChannel(value);
      break;
    case 2:
      var value = new proto.buying.consumer_search.api.v1.AggregationBucket;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.AggregationBucket.deserializeBinaryFromReader);
      msg.addBuckets(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setActivatedAtAfter(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setActivatedAtBefore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetProductAggregationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSalesChannel();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBucketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.buying.consumer_search.api.v1.AggregationBucket.serializeBinaryToWriter
    );
  }
  f = message.getActivatedAtAfter();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getActivatedAtBefore();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional SalesChannel sales_channel = 1;
 * @return {!proto.buying.consumer_search.api.v1.SalesChannel}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.getSalesChannel = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SalesChannel} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAggregationsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.setSalesChannel = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated AggregationBucket buckets = 2;
 * @return {!Array<!proto.buying.consumer_search.api.v1.AggregationBucket>}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.getBucketsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.AggregationBucket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.AggregationBucket, 2));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.AggregationBucket>} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAggregationsRequest} returns this
*/
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.setBucketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.AggregationBucket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucket}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.addBuckets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.buying.consumer_search.api.v1.AggregationBucket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAggregationsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.clearBucketsList = function() {
  return this.setBucketsList([]);
};


/**
 * optional google.protobuf.Timestamp activated_at_after = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.getActivatedAtAfter = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAggregationsRequest} returns this
*/
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.setActivatedAtAfter = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAggregationsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.clearActivatedAtAfter = function() {
  return this.setActivatedAtAfter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.hasActivatedAtAfter = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp activated_at_before = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.getActivatedAtBefore = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAggregationsRequest} returns this
*/
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.setActivatedAtBefore = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAggregationsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.clearActivatedAtBefore = function() {
  return this.setActivatedAtBefore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsRequest.prototype.hasActivatedAtBefore = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.AggregationValue.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.AggregationValue.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.AggregationValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.AggregationValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.AggregationValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, ""),
count: jspb.Message.getFieldWithDefault(msg, 2, 0),
bucketsList: jspb.Message.toObjectList(msg.getBucketsList(),
    proto.buying.consumer_search.api.v1.AggregationBucketResponse.toObject, includeInstance),
slug: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.AggregationValue}
 */
proto.buying.consumer_search.api.v1.AggregationValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.AggregationValue;
  return proto.buying.consumer_search.api.v1.AggregationValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.AggregationValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.AggregationValue}
 */
proto.buying.consumer_search.api.v1.AggregationValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    case 3:
      var value = new proto.buying.consumer_search.api.v1.AggregationBucketResponse;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.AggregationBucketResponse.deserializeBinaryFromReader);
      msg.addBuckets(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.AggregationValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.AggregationValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.AggregationValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.AggregationValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBucketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.buying.consumer_search.api.v1.AggregationBucketResponse.serializeBinaryToWriter
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.AggregationValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.AggregationValue} returns this
 */
proto.buying.consumer_search.api.v1.AggregationValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 count = 2;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.AggregationValue.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.AggregationValue} returns this
 */
proto.buying.consumer_search.api.v1.AggregationValue.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated AggregationBucketResponse buckets = 3;
 * @return {!Array<!proto.buying.consumer_search.api.v1.AggregationBucketResponse>}
 */
proto.buying.consumer_search.api.v1.AggregationValue.prototype.getBucketsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.AggregationBucketResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.AggregationBucketResponse, 3));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.AggregationBucketResponse>} value
 * @return {!proto.buying.consumer_search.api.v1.AggregationValue} returns this
*/
proto.buying.consumer_search.api.v1.AggregationValue.prototype.setBucketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.AggregationBucketResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucketResponse}
 */
proto.buying.consumer_search.api.v1.AggregationValue.prototype.addBuckets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.buying.consumer_search.api.v1.AggregationBucketResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AggregationValue} returns this
 */
proto.buying.consumer_search.api.v1.AggregationValue.prototype.clearBucketsList = function() {
  return this.setBucketsList([]);
};


/**
 * optional string slug = 4;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.AggregationValue.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.AggregationValue} returns this
 */
proto.buying.consumer_search.api.v1.AggregationValue.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.AggregationBucketResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.AggregationBucketResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.AggregationBucketResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.AggregationBucketResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.AggregationBucketResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
bucketName: jspb.Message.getFieldWithDefault(msg, 1, ""),
valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    proto.buying.consumer_search.api.v1.AggregationValue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucketResponse}
 */
proto.buying.consumer_search.api.v1.AggregationBucketResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.AggregationBucketResponse;
  return proto.buying.consumer_search.api.v1.AggregationBucketResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.AggregationBucketResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucketResponse}
 */
proto.buying.consumer_search.api.v1.AggregationBucketResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBucketName(value);
      break;
    case 2:
      var value = new proto.buying.consumer_search.api.v1.AggregationValue;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.AggregationValue.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.AggregationBucketResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.AggregationBucketResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.AggregationBucketResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.AggregationBucketResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucketName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.buying.consumer_search.api.v1.AggregationValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string bucket_name = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.AggregationBucketResponse.prototype.getBucketName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucketResponse} returns this
 */
proto.buying.consumer_search.api.v1.AggregationBucketResponse.prototype.setBucketName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated AggregationValue values = 2;
 * @return {!Array<!proto.buying.consumer_search.api.v1.AggregationValue>}
 */
proto.buying.consumer_search.api.v1.AggregationBucketResponse.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.AggregationValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.AggregationValue, 2));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.AggregationValue>} value
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucketResponse} returns this
*/
proto.buying.consumer_search.api.v1.AggregationBucketResponse.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.AggregationValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.AggregationValue}
 */
proto.buying.consumer_search.api.v1.AggregationBucketResponse.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.buying.consumer_search.api.v1.AggregationValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucketResponse} returns this
 */
proto.buying.consumer_search.api.v1.AggregationBucketResponse.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetProductAggregationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
bucketsList: jspb.Message.toObjectList(msg.getBucketsList(),
    proto.buying.consumer_search.api.v1.AggregationBucketResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAggregationsResponse}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetProductAggregationsResponse;
  return proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetProductAggregationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAggregationsResponse}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.consumer_search.api.v1.AggregationBucketResponse;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.AggregationBucketResponse.deserializeBinaryFromReader);
      msg.addBuckets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetProductAggregationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.consumer_search.api.v1.AggregationBucketResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AggregationBucketResponse buckets = 1;
 * @return {!Array<!proto.buying.consumer_search.api.v1.AggregationBucketResponse>}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.prototype.getBucketsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.AggregationBucketResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.AggregationBucketResponse, 1));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.AggregationBucketResponse>} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAggregationsResponse} returns this
*/
proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.prototype.setBucketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.AggregationBucketResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.AggregationBucketResponse}
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.prototype.addBuckets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.consumer_search.api.v1.AggregationBucketResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAggregationsResponse} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAggregationsResponse.prototype.clearBucketsList = function() {
  return this.setBucketsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.repeatedFields_ = [6,7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
collectionSlug: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageLimit: jspb.Message.getFieldWithDefault(msg, 2, 0),
pageNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
salesChannelId: jspb.Message.getFieldWithDefault(msg, 4, 0),
collectionId: jspb.Message.getFieldWithDefault(msg, 5, ""),
excludeProductIdsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
includeProductIdsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
includeProductSlugsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetCollectionContentsRequest;
  return proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCollectionSlug(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPageLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPageNumber(value);
      break;
    case 4:
      var value = /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (reader.readEnum());
      msg.setSalesChannelId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCollectionId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addExcludeProductIds(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addIncludeProductIds(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addIncludeProductSlugs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionSlug();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageLimit();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSalesChannelId();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCollectionId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getExcludeProductIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getIncludeProductIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getIncludeProductSlugsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
};


/**
 * optional string collection_slug = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.getCollectionSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.setCollectionSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 page_limit = 2;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.getPageLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.setPageLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 page_number = 3;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional SalesChannel sales_channel_id = 4;
 * @return {!proto.buying.consumer_search.api.v1.SalesChannel}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.getSalesChannelId = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SalesChannel} value
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.setSalesChannelId = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string collection_id = 5;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.getCollectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.setCollectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated string exclude_product_ids = 6;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.getExcludeProductIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.setExcludeProductIdsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.addExcludeProductIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.clearExcludeProductIdsList = function() {
  return this.setExcludeProductIdsList([]);
};


/**
 * repeated string include_product_ids = 7;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.getIncludeProductIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.setIncludeProductIdsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.addIncludeProductIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.clearIncludeProductIdsList = function() {
  return this.setIncludeProductIdsList([]);
};


/**
 * repeated string include_product_slugs = 8;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.getIncludeProductSlugsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.setIncludeProductSlugsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.addIncludeProductSlugs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsRequest.prototype.clearIncludeProductSlugsList = function() {
  return this.setIncludeProductSlugsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.CollectionProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.CollectionProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.CollectionProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
slug: jspb.Message.getFieldWithDefault(msg, 2, ""),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
pictureUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
releaseYear: jspb.Message.getFieldWithDefault(msg, 5, ""),
category: jspb.Message.getFieldWithDefault(msg, 6, ""),
seasonYear: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.CollectionProduct}
 */
proto.buying.consumer_search.api.v1.CollectionProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.CollectionProduct;
  return proto.buying.consumer_search.api.v1.CollectionProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.CollectionProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.CollectionProduct}
 */
proto.buying.consumer_search.api.v1.CollectionProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPictureUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleaseYear(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeasonYear(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.CollectionProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.CollectionProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.CollectionProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPictureUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getReleaseYear();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSeasonYear();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.CollectionProduct} returns this
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slug = 2;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.CollectionProduct} returns this
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.CollectionProduct} returns this
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string picture_url = 4;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.getPictureUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.CollectionProduct} returns this
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.setPictureUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string release_year = 5;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.getReleaseYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.CollectionProduct} returns this
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.setReleaseYear = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string category = 6;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.CollectionProduct} returns this
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string season_year = 7;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.getSeasonYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.CollectionProduct} returns this
 */
proto.buying.consumer_search.api.v1.CollectionProduct.prototype.setSeasonYear = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetCollectionContentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
totalResults: jspb.Message.getFieldWithDefault(msg, 1, 0),
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    proto.buying.consumer_search.api.v1.CollectionProduct.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsResponse}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetCollectionContentsResponse;
  return proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetCollectionContentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsResponse}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalResults(value);
      break;
    case 2:
      var value = new proto.buying.consumer_search.api.v1.CollectionProduct;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.CollectionProduct.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetCollectionContentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalResults();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.buying.consumer_search.api.v1.CollectionProduct.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 total_results = 1;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.prototype.getTotalResults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsResponse} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.prototype.setTotalResults = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated CollectionProduct products = 2;
 * @return {!Array<!proto.buying.consumer_search.api.v1.CollectionProduct>}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.CollectionProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.CollectionProduct, 2));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.CollectionProduct>} value
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsResponse} returns this
*/
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.CollectionProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.CollectionProduct}
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.buying.consumer_search.api.v1.CollectionProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetCollectionContentsResponse} returns this
 */
proto.buying.consumer_search.api.v1.GetCollectionContentsResponse.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetRecordCountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetRecordCountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetRecordCountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetRecordCountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
salesChannel: jspb.Message.getFieldWithDefault(msg, 1, 0),
recordType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetRecordCountRequest}
 */
proto.buying.consumer_search.api.v1.GetRecordCountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetRecordCountRequest;
  return proto.buying.consumer_search.api.v1.GetRecordCountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetRecordCountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetRecordCountRequest}
 */
proto.buying.consumer_search.api.v1.GetRecordCountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (reader.readEnum());
      msg.setSalesChannel(value);
      break;
    case 2:
      var value = /** @type {!proto.buying.consumer_search.api.v1.RecordType} */ (reader.readEnum());
      msg.setRecordType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetRecordCountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetRecordCountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetRecordCountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetRecordCountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSalesChannel();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRecordType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional SalesChannel sales_channel = 1;
 * @return {!proto.buying.consumer_search.api.v1.SalesChannel}
 */
proto.buying.consumer_search.api.v1.GetRecordCountRequest.prototype.getSalesChannel = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SalesChannel} value
 * @return {!proto.buying.consumer_search.api.v1.GetRecordCountRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordCountRequest.prototype.setSalesChannel = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional RecordType record_type = 2;
 * @return {!proto.buying.consumer_search.api.v1.RecordType}
 */
proto.buying.consumer_search.api.v1.GetRecordCountRequest.prototype.getRecordType = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.RecordType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.RecordType} value
 * @return {!proto.buying.consumer_search.api.v1.GetRecordCountRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordCountRequest.prototype.setRecordType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetRecordCountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetRecordCountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetRecordCountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetRecordCountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
totalResults: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetRecordCountResponse}
 */
proto.buying.consumer_search.api.v1.GetRecordCountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetRecordCountResponse;
  return proto.buying.consumer_search.api.v1.GetRecordCountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetRecordCountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetRecordCountResponse}
 */
proto.buying.consumer_search.api.v1.GetRecordCountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetRecordCountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetRecordCountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetRecordCountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetRecordCountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalResults();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 total_results = 1;
 * @return {number}
 */
proto.buying.consumer_search.api.v1.GetRecordCountResponse.prototype.getTotalResults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.consumer_search.api.v1.GetRecordCountResponse} returns this
 */
proto.buying.consumer_search.api.v1.GetRecordCountResponse.prototype.setTotalResults = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
salesChannel: jspb.Message.getFieldWithDefault(msg, 1, 0),
productId: jspb.Message.getFieldWithDefault(msg, 2, ""),
sizeUs: jspb.Message.getFieldWithDefault(msg, 3, ""),
productCondition: jspb.Message.getFieldWithDefault(msg, 4, 0),
countryCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
boxCondition: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest;
  return proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (reader.readEnum());
      msg.setSalesChannel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSizeUs(value);
      break;
    case 4:
      var value = /** @type {!proto.buying.consumer_search.api.v1.ProductCondition} */ (reader.readEnum());
      msg.setProductCondition(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 6:
      var value = /** @type {!proto.buying.consumer_search.api.v1.BoxCondition} */ (reader.readEnum());
      msg.setBoxCondition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSalesChannel();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSizeUs();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProductCondition();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBoxCondition();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional SalesChannel sales_channel = 1;
 * @return {!proto.buying.consumer_search.api.v1.SalesChannel}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.getSalesChannel = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SalesChannel} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.setSalesChannel = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string product_id = 2;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string size_us = 3;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.getSizeUs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.setSizeUs = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional ProductCondition product_condition = 4;
 * @return {!proto.buying.consumer_search.api.v1.ProductCondition}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.getProductCondition = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.ProductCondition} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.ProductCondition} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.setProductCondition = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string country_code = 5;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional BoxCondition box_condition = 6;
 * @return {!proto.buying.consumer_search.api.v1.BoxCondition}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.getBoxCondition = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.BoxCondition} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.BoxCondition} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityRequest.prototype.setBoxCondition = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
variant: (f = msg.getVariant()) && proto.buying.consumer_search.api.v1.Variant.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse;
  return proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.consumer_search.api.v1.Variant;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.Variant.deserializeBinaryFromReader);
      msg.setVariant(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVariant();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.buying.consumer_search.api.v1.Variant.serializeBinaryToWriter
    );
  }
};


/**
 * optional Variant variant = 1;
 * @return {?proto.buying.consumer_search.api.v1.Variant}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.prototype.getVariant = function() {
  return /** @type{?proto.buying.consumer_search.api.v1.Variant} */ (
    jspb.Message.getWrapperField(this, proto.buying.consumer_search.api.v1.Variant, 1));
};


/**
 * @param {?proto.buying.consumer_search.api.v1.Variant|undefined} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse} returns this
*/
proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.prototype.setVariant = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.prototype.clearVariant = function() {
  return this.setVariant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilityResponse.prototype.hasVariant = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
salesChannel: jspb.Message.getFieldWithDefault(msg, 1, 0),
productId: jspb.Message.getFieldWithDefault(msg, 2, ""),
sizeUs: jspb.Message.getFieldWithDefault(msg, 3, ""),
productCondition: jspb.Message.getFieldWithDefault(msg, 4, 0),
countryCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
boxCondition: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest;
  return proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (reader.readEnum());
      msg.setSalesChannel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSizeUs(value);
      break;
    case 4:
      var value = /** @type {!proto.buying.consumer_search.api.v1.ProductCondition} */ (reader.readEnum());
      msg.setProductCondition(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 6:
      var value = /** @type {!proto.buying.consumer_search.api.v1.BoxCondition} */ (reader.readEnum());
      msg.setBoxCondition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSalesChannel();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSizeUs();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProductCondition();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBoxCondition();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional SalesChannel sales_channel = 1;
 * @return {!proto.buying.consumer_search.api.v1.SalesChannel}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.getSalesChannel = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SalesChannel} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.setSalesChannel = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string product_id = 2;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string size_us = 3;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.getSizeUs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.setSizeUs = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional ProductCondition product_condition = 4;
 * @return {!proto.buying.consumer_search.api.v1.ProductCondition}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.getProductCondition = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.ProductCondition} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.ProductCondition} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.setProductCondition = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string country_code = 5;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional BoxCondition box_condition = 6;
 * @return {!proto.buying.consumer_search.api.v1.BoxCondition}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.getBoxCondition = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.BoxCondition} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.BoxCondition} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesRequest.prototype.setBoxCondition = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
variantsList: jspb.Message.toObjectList(msg.getVariantsList(),
    proto.buying.consumer_search.api.v1.Variant.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse;
  return proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.consumer_search.api.v1.Variant;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.Variant.deserializeBinaryFromReader);
      msg.addVariants(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVariantsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.consumer_search.api.v1.Variant.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Variant variants = 1;
 * @return {!Array<!proto.buying.consumer_search.api.v1.Variant>}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.prototype.getVariantsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.Variant>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.Variant, 1));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.Variant>} value
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse} returns this
*/
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.prototype.setVariantsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.Variant=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.Variant}
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.prototype.addVariants = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.consumer_search.api.v1.Variant, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse} returns this
 */
proto.buying.consumer_search.api.v1.GetProductAvailabilitiesResponse.prototype.clearVariantsList = function() {
  return this.setVariantsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
salesChannel: jspb.Message.getFieldWithDefault(msg, 1, 0),
productIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest}
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest;
  return proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest}
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (reader.readEnum());
      msg.setSalesChannel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addProductIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSalesChannel();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getProductIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional SalesChannel sales_channel = 1;
 * @return {!proto.buying.consumer_search.api.v1.SalesChannel}
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.prototype.getSalesChannel = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SalesChannel} value
 * @return {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.prototype.setSalesChannel = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated string product_ids = 2;
 * @return {!Array<string>}
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.prototype.getProductIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.prototype.setProductIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.prototype.addProductIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsRequest.prototype.clearProductIdsList = function() {
  return this.setProductIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
variantsList: jspb.Message.toObjectList(msg.getVariantsList(),
    proto.buying.consumer_search.api.v1.Variant.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse}
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse;
  return proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse}
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.consumer_search.api.v1.Variant;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.Variant.deserializeBinaryFromReader);
      msg.addVariants(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVariantsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.consumer_search.api.v1.Variant.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Variant variants = 1;
 * @return {!Array<!proto.buying.consumer_search.api.v1.Variant>}
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.prototype.getVariantsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.Variant>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.Variant, 1));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.Variant>} value
 * @return {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse} returns this
*/
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.prototype.setVariantsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.Variant=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.Variant}
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.prototype.addVariants = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.consumer_search.api.v1.Variant, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse} returns this
 */
proto.buying.consumer_search.api.v1.GetLowestPriceForProductsResponse.prototype.clearVariantsList = function() {
  return this.setVariantsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetSubCollectionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
salesChannelId: jspb.Message.getFieldWithDefault(msg, 1, 0),
collectionSlug: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetSubCollectionsRequest}
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetSubCollectionsRequest;
  return proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetSubCollectionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetSubCollectionsRequest}
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (reader.readEnum());
      msg.setSalesChannelId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCollectionSlug(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetSubCollectionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSalesChannelId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCollectionSlug();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional SalesChannel sales_channel_id = 1;
 * @return {!proto.buying.consumer_search.api.v1.SalesChannel}
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.prototype.getSalesChannelId = function() {
  return /** @type {!proto.buying.consumer_search.api.v1.SalesChannel} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SalesChannel} value
 * @return {!proto.buying.consumer_search.api.v1.GetSubCollectionsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.prototype.setSalesChannelId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string collection_slug = 2;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.prototype.getCollectionSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.GetSubCollectionsRequest} returns this
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsRequest.prototype.setCollectionSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.SubCollection.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.SubCollection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.SubCollection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.SubCollection.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
collectionSlug: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.SubCollection}
 */
proto.buying.consumer_search.api.v1.SubCollection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.SubCollection;
  return proto.buying.consumer_search.api.v1.SubCollection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.SubCollection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.SubCollection}
 */
proto.buying.consumer_search.api.v1.SubCollection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCollectionSlug(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.SubCollection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.SubCollection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.SubCollection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.SubCollection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCollectionSlug();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.SubCollection.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.SubCollection} returns this
 */
proto.buying.consumer_search.api.v1.SubCollection.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string collection_slug = 2;
 * @return {string}
 */
proto.buying.consumer_search.api.v1.SubCollection.prototype.getCollectionSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.consumer_search.api.v1.SubCollection} returns this
 */
proto.buying.consumer_search.api.v1.SubCollection.prototype.setCollectionSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.consumer_search.api.v1.GetSubCollectionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
subCollectionsList: jspb.Message.toObjectList(msg.getSubCollectionsList(),
    proto.buying.consumer_search.api.v1.SubCollection.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.consumer_search.api.v1.GetSubCollectionsResponse}
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.consumer_search.api.v1.GetSubCollectionsResponse;
  return proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.consumer_search.api.v1.GetSubCollectionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.consumer_search.api.v1.GetSubCollectionsResponse}
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.consumer_search.api.v1.SubCollection;
      reader.readMessage(value,proto.buying.consumer_search.api.v1.SubCollection.deserializeBinaryFromReader);
      msg.addSubCollections(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.consumer_search.api.v1.GetSubCollectionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubCollectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.consumer_search.api.v1.SubCollection.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SubCollection sub_collections = 1;
 * @return {!Array<!proto.buying.consumer_search.api.v1.SubCollection>}
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.prototype.getSubCollectionsList = function() {
  return /** @type{!Array<!proto.buying.consumer_search.api.v1.SubCollection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.consumer_search.api.v1.SubCollection, 1));
};


/**
 * @param {!Array<!proto.buying.consumer_search.api.v1.SubCollection>} value
 * @return {!proto.buying.consumer_search.api.v1.GetSubCollectionsResponse} returns this
*/
proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.prototype.setSubCollectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.consumer_search.api.v1.SubCollection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.consumer_search.api.v1.SubCollection}
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.prototype.addSubCollections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.consumer_search.api.v1.SubCollection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.consumer_search.api.v1.GetSubCollectionsResponse} returns this
 */
proto.buying.consumer_search.api.v1.GetSubCollectionsResponse.prototype.clearSubCollectionsList = function() {
  return this.setSubCollectionsList([]);
};


/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.RecordType = {
  RECORD_TYPE_INVALID: 0,
  RECORD_TYPE_COLLECTION: 1,
  RECORD_TYPE_AUCTION: 2,
  RECORD_TYPE_EDITORIAL: 3,
  RECORD_TYPE_PRODUCT: 4,
  RECORD_TYPE_DROP: 5,
  RECORD_TYPE_TRIVIA: 6,
  RECORD_TYPE_GIFT_SHOP_PRODUCT: 7
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.SalesChannel = {
  SALES_CHANNEL_INVALID: 0,
  SALES_CHANNEL_GOAT: 1,
  SALES_CHANNEL_FLIGHT_CLUB: 2,
  SALES_CHANNEL_WECHAT: 3,
  SALES_CHANNEL_TMALL: 4,
  SALES_CHANNEL_SNEAKERS_DOT_COM: 5
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.CollapseOn = {
  COLLAPSE_ON_INVALID: 0,
  COLLAPSE_ON_RECORD_TYPE: 1
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.EventGroup = {
  EVENT_GROUP_INVALID: 0,
  EVENT_GROUP_BLACK_FRIDAY: 1
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.Tag = {
  TAG_INVALID: 0,
  TAG_BLACK_FRIDAY: 1,
  TAG_PRIVATE: 2,
  TAG_HIDE_ON_RELATED: 3,
  TAG_SOLD_OUT: 4
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.EventSortType = {
  EVENT_SORT_INVALID: 0,
  EVENT_SORT_EVENT_TIME_ASC: 1,
  EVENT_SORT_EVENT_TIME_DESC: 2
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.ProductCondition = {
  PRODUCT_CONDITION_INVALID: 0,
  NEW_NO_DEFECTS: 1,
  NEW_WITH_DEFECTS: 2,
  USED: 3,
  GOAT_CLEAN: 4
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.BoxCondition = {
  BOX_CONDITION_INVALID: 0,
  GOOD_CONDITION: 1,
  MISSING_LID: 2,
  BADLY_DAMAGED: 3,
  NO_ORIGINAL_BOX: 4
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.ForProductSortType = {
  FOR_PRODUCT_SORT_TYPE_INVALID: 0,
  FOR_PRODUCT_SORT_TYPE_UPDATED_AT_DESC: 1
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.SizeFilterProductType = {
  SIZE_FILTER_PRODUCT_TYPE_INVALID: 0,
  SIZE_FILTER_PRODUCT_TYPE_SHOES: 1,
  SIZE_FILTER_PRODUCT_TYPE_TOPS: 2,
  SIZE_FILTER_PRODUCT_TYPE_BOTTOMS: 3,
  SIZE_FILTER_PRODUCT_TYPE_OUTERWEAR: 4,
  SIZE_FILTER_PRODUCT_TYPE_DRESSES: 5,
  SIZE_FILTER_PRODUCT_TYPE_BELTS: 6
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.SizeFilterGender = {
  SIZE_FILTER_GENDER_INVALID: 0,
  SIZE_FILTER_GENDER_MEN: 1,
  SIZE_FILTER_GENDER_WOMEN: 2,
  SIZE_FILTER_GENDER_YOUTH: 3,
  SIZE_FILTER_GENDER_INFANT: 4
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.SizeFilterSizeUnit = {
  SIZE_FILTER_SIZE_UNIT_INVALID: 0,
  SIZE_FILTER_SIZE_UNIT_US: 1,
  SIZE_FILTER_SIZE_UNIT_UK: 2,
  SIZE_FILTER_SIZE_UNIT_IT: 3,
  SIZE_FILTER_SIZE_UNIT_FR: 4,
  SIZE_FILTER_SIZE_UNIT_EU: 5,
  SIZE_FILTER_SIZE_UNIT_JP: 6,
  SIZE_FILTER_SIZE_UNIT_UNIVERSAL: 7
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.ProductSortType = {
  PRODUCT_SORT_TYPE_INVALID: 0,
  POPULARITY_DESC: 1,
  RELEASE_DATE_DESC: 2,
  PRICE_ASC: 3,
  PRICE_DESC: 4,
  TRENDING_PURCHASE_DESC: 5,
  RANDOM: 6,
  DISCOUNT_PERCENTAGE_DESC: 7
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.Aggregation = {
  AGGREGATION_INVALID: 0,
  AGGREGATION_BRAND: 1,
  AGGREGATION_CATEGORY: 2,
  AGGREGATION_COLOR: 3,
  AGGREGATION_GENDER: 4,
  AGGREGATION_PRODUCT_TYPE: 5,
  AGGREGATION_RELEASE_YEAR: 6,
  AGGREGATION_SILHOUETTE: 7,
  AGGREGATION_ACTIVITY: 8,
  AGGREGATION_PRODUCT_CONDITION: 9,
  AGGREGATION_SIZE: 10,
  AGGREGATION_DESIGNER: 11,
  AGGREGATION_SEASON: 12
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.AggregationType = {
  AGGREGATION_TYPE_INVALID: 0,
  AGGREGATION_TYPE_DEFAULT: 1
};

/**
 * @enum {number}
 */
proto.buying.consumer_search.api.v1.AggregationField = {
  AGGREGATION_FIELD_INVALID: 0,
  AGGREGATION_FIELD_BRAND: 1,
  AGGREGATION_FIELD_ACTIVITY: 2,
  AGGREGATION_FIELD_GENDER: 3,
  AGGREGATION_FIELD_COLOR: 4
};

goog.object.extend(exports, proto.buying.consumer_search.api.v1);
